import { gql } from '@apollo/client';
import * as React from 'react';
import * as Apollo from '@apollo/client';
import * as ApolloReactComponents from '@apollo/client/react/components';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** unique or primary key constraints on table "mix_admin" */
export enum Mix_Admin_Constraint {
  /** unique or primary key constraint on columns "email" */
  MixAdminEmailKey = 'mix_admin_email_key',
  /** unique or primary key constraint on columns "id" */
  MixAdminPkey = 'mix_admin_pkey'
}

/** select columns of table "mix_admin" */
export enum Mix_Admin_Select_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password'
}

/** update columns of table "mix_admin" */
export enum Mix_Admin_Update_Column {
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Password = 'password'
}

/** unique or primary key constraints on table "mix_archive_bookmark" */
export enum Mix_Archive_Bookmark_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixArchiveBookmarkPkey = 'mix_archive_bookmark_pkey',
  /** unique or primary key constraint on columns "userid", "archiveid" */
  MixArchiveBookmarkUseridArchiveidKey = 'mix_archive_bookmark_userid_archiveid_key'
}

/** select columns of table "mix_archive_bookmark" */
export enum Mix_Archive_Bookmark_Select_Column {
  /** column name */
  Archiveid = 'archiveid',
  /** column name */
  Id = 'id',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  Userid = 'userid'
}

/** update columns of table "mix_archive_bookmark" */
export enum Mix_Archive_Bookmark_Update_Column {
  /** column name */
  Archiveid = 'archiveid',
  /** column name */
  Id = 'id',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  Userid = 'userid'
}

/** unique or primary key constraints on table "mix_archive" */
export enum Mix_Archive_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixArchivePkey = 'mix_archive_pkey'
}

/** select columns of table "mix_archive" */
export enum Mix_Archive_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DownloadUrl = 'download_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsMainExposed = 'is_main_exposed',
  /** column name */
  Source = 'source',
  /** column name */
  Sourcename = 'sourcename',
  /** column name */
  Tags = 'tags',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewUrl = 'view_url'
}

/** unique or primary key constraints on table "mix_archive_tags" */
export enum Mix_Archive_Tags_Constraint {
  /** unique or primary key constraint on columns "value" */
  MixArchiveTagsPkey = 'mix_archive_tags_pkey'
}

/** select columns of table "mix_archive_tags" */
export enum Mix_Archive_Tags_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_archive_tags" */
export enum Mix_Archive_Tags_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_archive" */
export enum Mix_Archive_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DownloadUrl = 'download_url',
  /** column name */
  Id = 'id',
  /** column name */
  IsMainExposed = 'is_main_exposed',
  /** column name */
  Source = 'source',
  /** column name */
  Sourcename = 'sourcename',
  /** column name */
  Tags = 'tags',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  ViewUrl = 'view_url'
}

/** unique or primary key constraints on table "mix_author" */
export enum Mix_Author_Constraint {
  /** unique or primary key constraint on columns "source", "authorid" */
  MixAuthorPkey = 'mix_author_pkey'
}

/** select columns of table "mix_author" */
export enum Mix_Author_Select_Column {
  /** column name */
  Authorid = 'authorid',
  /** column name */
  Authorname = 'authorname',
  /** column name */
  Source = 'source',
  /** column name */
  Tier = 'tier'
}

/** unique or primary key constraints on table "mix_author_tier" */
export enum Mix_Author_Tier_Constraint {
  /** unique or primary key constraint on columns "tier" */
  MixAuthorTierPkey = 'mix_author_tier_pkey'
}

/** select columns of table "mix_author_tier" */
export enum Mix_Author_Tier_Select_Column {
  /** column name */
  Tier = 'tier'
}

/** update columns of table "mix_author_tier" */
export enum Mix_Author_Tier_Update_Column {
  /** column name */
  Tier = 'tier'
}

/** update columns of table "mix_author" */
export enum Mix_Author_Update_Column {
  /** column name */
  Authorid = 'authorid',
  /** column name */
  Authorname = 'authorname',
  /** column name */
  Source = 'source',
  /** column name */
  Tier = 'tier'
}

/** unique or primary key constraints on table "mix_class_course" */
export enum Mix_Class_Course_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixClassCoursePkey = 'mix_class_course_pkey'
}

/** unique or primary key constraints on table "mix_class_course_progress" */
export enum Mix_Class_Course_Progress_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixClassCourseProgressPkey = 'mix_class_course_progress_pkey',
  /** unique or primary key constraint on columns "user_id", "course_id" */
  MixClassCourseProgressUserIdCourseIdKey = 'mix_class_course_progress_user_id_course_id_key'
}

/** select columns of table "mix_class_course_progress" */
export enum Mix_Class_Course_Progress_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastWatched = 'last_watched',
  /** column name */
  Progress = 'progress',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "mix_class_course_progress" */
export enum Mix_Class_Course_Progress_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  LastWatched = 'last_watched',
  /** column name */
  Progress = 'progress',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select columns of table "mix_class_course" */
export enum Mix_Class_Course_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InstructorName = 'instructor_name',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  TotalLectures = 'total_lectures',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "mix_class_course_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_class_course" */
export enum Mix_Class_Course_Select_Column_Mix_Class_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** select "mix_class_course_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_class_course" */
export enum Mix_Class_Course_Select_Column_Mix_Class_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsActive = 'is_active'
}

/** update columns of table "mix_class_course" */
export enum Mix_Class_Course_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  InstructorName = 'instructor_name',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  ThumbnailUrl = 'thumbnail_url',
  /** column name */
  Title = 'title',
  /** column name */
  TotalLectures = 'total_lectures',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** unique or primary key constraints on table "mix_class_lecture" */
export enum Mix_Class_Lecture_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixClassLecturePkey = 'mix_class_lecture_pkey'
}

/** unique or primary key constraints on table "mix_class_lecture_progress" */
export enum Mix_Class_Lecture_Progress_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixClassLectureProgressPkey = 'mix_class_lecture_progress_pkey'
}

/** select columns of table "mix_class_lecture_progress" */
export enum Mix_Class_Lecture_Progress_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lecture_id',
  /** column name */
  Progress = 'progress',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WatchTime = 'watch_time'
}

/** update columns of table "mix_class_lecture_progress" */
export enum Mix_Class_Lecture_Progress_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  LectureId = 'lecture_id',
  /** column name */
  Progress = 'progress',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  WatchTime = 'watch_time'
}

/** select columns of table "mix_class_lecture" */
export enum Mix_Class_Lecture_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  HasMaterials = 'has_materials',
  /** column name */
  Id = 'id',
  /** column name */
  LectureOrder = 'lecture_order',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoUrl = 'video_url'
}

/** select "mix_class_lecture_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_class_lecture" */
export enum Mix_Class_Lecture_Select_Column_Mix_Class_Lecture_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasMaterials = 'has_materials'
}

/** select "mix_class_lecture_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_class_lecture" */
export enum Mix_Class_Lecture_Select_Column_Mix_Class_Lecture_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasMaterials = 'has_materials'
}

/** update columns of table "mix_class_lecture" */
export enum Mix_Class_Lecture_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Duration = 'duration',
  /** column name */
  HasMaterials = 'has_materials',
  /** column name */
  Id = 'id',
  /** column name */
  LectureOrder = 'lecture_order',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  VideoUrl = 'video_url'
}

/** unique or primary key constraints on table "mix_class_status" */
export enum Mix_Class_Status_Constraint {
  /** unique or primary key constraint on columns "status" */
  MixClassStatusPkey = 'mix_class_status_pkey'
}

/** select columns of table "mix_class_status" */
export enum Mix_Class_Status_Select_Column {
  /** column name */
  Status = 'status'
}

/** update columns of table "mix_class_status" */
export enum Mix_Class_Status_Update_Column {
  /** column name */
  Status = 'status'
}

/** unique or primary key constraints on table "mix_content_bookmark" */
export enum Mix_Content_Bookmark_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixContentBookmarkPkey = 'mix_content_bookmark_pkey',
  /** unique or primary key constraint on columns "userid", "contentid" */
  MixContentBookmarkUseridContentidKey = 'mix_content_bookmark_userid_contentid_key'
}

/** select columns of table "mix_content_bookmark" */
export enum Mix_Content_Bookmark_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  Userid = 'userid'
}

/** update columns of table "mix_content_bookmark" */
export enum Mix_Content_Bookmark_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  Userid = 'userid'
}

/** unique or primary key constraints on table "mix_content_category" */
export enum Mix_Content_Category_Constraint {
  /** unique or primary key constraint on columns "value" */
  MixContentCategoryEnumPkey = 'mix_content_category_enum_pkey'
}

export enum Mix_Content_Category_Enum {
  /** 믹스 앰배서더 */
  Ambassador = 'Ambassador',
  /** 베스트 콘텐츠 */
  BestContents = 'Best_Contents',
  /** CMO 인터뷰 */
  Cmo = 'CMO',
  /** 이벤트 */
  Event = 'Event',
  /** 글로벌 인사이트 */
  GlobalInsight = 'Global_Insight',
  /** 인터뷰 */
  Interview = 'Interview',
  /** 오프라인 세션 */
  Offline = 'Offline',
  /** 리포트 발행 */
  Report = 'Report'
}

/** select columns of table "mix_content_category" */
export enum Mix_Content_Category_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_content_category" */
export enum Mix_Content_Category_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** unique or primary key constraints on table "mix_content" */
export enum Mix_Content_Constraint {
  /** unique or primary key constraint on columns "contentid", "author" */
  MixContentAuthorContentidKey = 'mix_content_author_contentid_key',
  /** unique or primary key constraint on columns "id", "default_product_id" */
  MixContentIdDefaultProductIdKey = 'mix_content_id_default_product_id_key',
  /** unique or primary key constraint on columns "recommendorder" */
  MixContentRecommendedKey = 'mix_content_recommended_key',
  /** unique or primary key constraint on columns "contentid", "source" */
  MixContentSourceContentidKey = 'mix_content_source_contentid_key',
  /** unique or primary key constraint on columns "id" */
  MixContentTablePkey = 'mix_content_table_pkey'
}

/** unique or primary key constraints on table "mix_content_daily_selected" */
export enum Mix_Content_Daily_Selected_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixContentDailySelectedPkey = 'mix_content_daily_selected_pkey'
}

/** select columns of table "mix_content_daily_selected" */
export enum Mix_Content_Daily_Selected_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Ordernum = 'ordernum',
  /** column name */
  Published = 'published',
  /** column name */
  Updatetime = 'updatetime'
}

/** update columns of table "mix_content_daily_selected" */
export enum Mix_Content_Daily_Selected_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Ordernum = 'ordernum',
  /** column name */
  Published = 'published',
  /** column name */
  Updatetime = 'updatetime'
}

/** unique or primary key constraints on table "mix_content_encore" */
export enum Mix_Content_Encore_Constraint {
  /** unique or primary key constraint on columns "userid", "contentid" */
  MixContentEncoreContentidUseridKey = 'mix_content_encore_contentid_userid_key',
  /** unique or primary key constraint on columns "id" */
  MixContentEncorePkey = 'mix_content_encore_pkey'
}

/** select columns of table "mix_content_encore" */
export enum Mix_Content_Encore_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Count = 'count',
  /** column name */
  Id = 'id',
  /** column name */
  Userid = 'userid'
}

/** update columns of table "mix_content_encore" */
export enum Mix_Content_Encore_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Count = 'count',
  /** column name */
  Id = 'id',
  /** column name */
  Userid = 'userid'
}

/** unique or primary key constraints on table "mix_content_history" */
export enum Mix_Content_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixContentHistoryPkey = 'mix_content_history_pkey',
  /** unique or primary key constraint on columns "userid", "contentid" */
  MixContentHistoryUseridContentidKey = 'mix_content_history_userid_contentid_key'
}

/** select columns of table "mix_content_history" */
export enum Mix_Content_History_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  Userid = 'userid'
}

/** update columns of table "mix_content_history" */
export enum Mix_Content_History_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  Userid = 'userid'
}

/** unique or primary key constraints on table "mix_content_popular_all_time" */
export enum Mix_Content_Popular_All_Time_Constraint {
  /** unique or primary key constraint on columns "data_source", "content_id" */
  MixContentPopularAllTimeContentIdDataSourceKey = 'mix_content_popular_all_time_content_id_data_source_key',
  /** unique or primary key constraint on columns "id" */
  MixContentPopularAllTimePkey = 'mix_content_popular_all_time_pkey'
}

/** select columns of table "mix_content_popular_all_time" */
export enum Mix_Content_Popular_All_Time_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  ViewCount = 'view_count'
}

/** update columns of table "mix_content_popular_all_time" */
export enum Mix_Content_Popular_All_Time_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdated = 'last_updated',
  /** column name */
  ViewCount = 'view_count'
}

/** select columns of table "mix_content_popular_all_time_view" */
export enum Mix_Content_Popular_All_Time_View_Select_Column {
  /** column name */
  Abstractcontents = 'abstractcontents',
  /** column name */
  Author = 'author',
  /** column name */
  Authorname = 'authorname',
  /** column name */
  Category = 'category',
  /** column name */
  Contentid = 'contentid',
  /** column name */
  CoverImgurl = 'cover_imgurl',
  /** column name */
  DataSource = 'data_source',
  /** column name */
  DefaultProductId = 'default_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  Imgurl = 'imgurl',
  /** column name */
  Offlineapplyurl = 'offlineapplyurl',
  /** column name */
  Offlinetime = 'offlinetime',
  /** column name */
  Originalurl = 'originalurl',
  /** column name */
  Pdfpagecount = 'pdfpagecount',
  /** column name */
  Pdfurl = 'pdfurl',
  /** column name */
  PopularityLastUpdated = 'popularity_last_updated',
  /** column name */
  Price = 'price',
  /** column name */
  Readtime = 'readtime',
  /** column name */
  Recommendorder = 'recommendorder',
  /** column name */
  Redirecturl = 'redirecturl',
  /** column name */
  Reviewer = 'reviewer',
  /** column name */
  Reviewtime = 'reviewtime',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Updatetime = 'updatetime',
  /** column name */
  ViewCount = 'view_count'
}

/** select columns of table "mix_content_popular_last_7days_view" */
export enum Mix_Content_Popular_Last_7days_View_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  ViewCount = 'view_count'
}

/** select columns of table "mix_content_popular_last_24h_view" */
export enum Mix_Content_Popular_Last_24h_View_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  ViewCount = 'view_count'
}

/** unique or primary key constraints on table "mix_content_recommend" */
export enum Mix_Content_Recommend_Constraint {
  /** unique or primary key constraint on columns "priority", "updatedate" */
  MixContentRecommendUpdatedatePriorityKey = 'mix_content_recommend_updatedate_priority_key',
  /** unique or primary key constraint on columns "id" */
  MixContentWeeklySelectedPkey = 'mix_content_weekly_selected_pkey'
}

/** select columns of table "mix_content_recommend" */
export enum Mix_Content_Recommend_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Published = 'published',
  /** column name */
  Updatedate = 'updatedate'
}

/** select "mix_content_recommend_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_content_recommend" */
export enum Mix_Content_Recommend_Select_Column_Mix_Content_Recommend_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Published = 'published'
}

/** select "mix_content_recommend_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_content_recommend" */
export enum Mix_Content_Recommend_Select_Column_Mix_Content_Recommend_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Published = 'published'
}

/** update columns of table "mix_content_recommend" */
export enum Mix_Content_Recommend_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Id = 'id',
  /** column name */
  Priority = 'priority',
  /** column name */
  Published = 'published',
  /** column name */
  Updatedate = 'updatedate'
}

/** select columns of table "mix_content" */
export enum Mix_Content_Select_Column {
  /** column name */
  Abstractcontents = 'abstractcontents',
  /** column name */
  Author = 'author',
  /** column name */
  Authorname = 'authorname',
  /** column name */
  Category = 'category',
  /** column name */
  Contentid = 'contentid',
  /** column name */
  CoverImgurl = 'cover_imgurl',
  /** column name */
  DefaultProductId = 'default_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  Imgurl = 'imgurl',
  /** column name */
  Offlineapplyurl = 'offlineapplyurl',
  /** column name */
  Offlinetime = 'offlinetime',
  /** column name */
  Originalurl = 'originalurl',
  /** column name */
  Pdfpagecount = 'pdfpagecount',
  /** column name */
  Pdfurl = 'pdfurl',
  /** column name */
  Price = 'price',
  /** column name */
  Readtime = 'readtime',
  /** column name */
  Recommendorder = 'recommendorder',
  /** column name */
  Redirecturl = 'redirecturl',
  /** column name */
  Reviewer = 'reviewer',
  /** column name */
  Reviewtime = 'reviewtime',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Updatetime = 'updatetime'
}

/** unique or primary key constraints on table "mix_content_status" */
export enum Mix_Content_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  MixContentStatusPkey = 'mix_content_status_pkey'
}

export enum Mix_Content_Status_Enum {
  Crawled = 'crawled',
  PartialPublished = 'partial_published',
  Published = 'published',
  Rejected = 'rejected',
  Scheduled = 'scheduled'
}

/** select columns of table "mix_content_status" */
export enum Mix_Content_Status_Select_Column {
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_content_status" */
export enum Mix_Content_Status_Update_Column {
  /** column name */
  Value = 'value'
}

/** unique or primary key constraints on table "mix_content_tag" */
export enum Mix_Content_Tag_Constraint {
  /** unique or primary key constraint on columns "tag", "contentid" */
  MixContentTagPkey1 = 'mix_content_tag_pkey1'
}

/** unique or primary key constraints on table "mix_content_tag_enum" */
export enum Mix_Content_Tag_Enum_Constraint {
  /** unique or primary key constraint on columns "value" */
  MixContentTagPkey = 'mix_content_tag_pkey'
}

export enum Mix_Content_Tag_Enum_Enum {
  /** 제휴마케팅 */
  AffiliateMarketing = 'affiliate_marketing',
  /** AI트렌드 */
  AiTrend = 'ai_trend',
  /** B2B마케팅 */
  B2bMarketing = 'b2b_marketing',
  /** 브랜드마케팅 */
  BrandMarketing = 'brand_marketing',
  /** 비즈니스 */
  Business = 'business',
  /** 커리어 */
  Career = 'career',
  /** 소비자심리 */
  ConsumerPsy = 'consumer_psy',
  /** 콘텐츠마케팅 */
  ContentMarketing = 'content_marketing',
  /** CRM마케팅 */
  CrmMarketing = 'crm_marketing',
  /** 문화예술 */
  CultureArts = 'culture_arts',
  /** 그로스해킹 */
  GrowthHacking = 'growth_hacking',
  /** 마켓트렌드 */
  MarketTrend = 'market_trend',
  /** 일반마케팅 */
  NormalMarketing = 'normal_marketing',
  /** 퍼포먼스마케팅 */
  PerformanceMarketing = 'performance_marketing',
  /** SEO */
  Seo = 'seo',
  /** 금융시장 */
  ShinhaninvestFinancialMarket = 'shinhaninvest_financial_market',
  /** 글로벌이슈 */
  ShinhaninvestGlobalIssue = 'shinhaninvest_global_issue',
  /** 거시경제 */
  ShinhaninvestMacroEconomy = 'shinhaninvest_macro_economy',
  /** 증권사이벤트 */
  ShinhaninvestSecuritiesEvent = 'shinhaninvest_securities_event',
  /** 증권사동향 */
  ShinhaninvestSecuritiesTrend = 'shinhaninvest_securities_trend',
  /** 신한투자증권 */
  ShinhaninvestShinhansec = 'shinhaninvest_shinhansec',
  /** 미래에셋증권 */
  Trial_1 = 'trial_1',
  /** 금융트렌드 */
  Trial_2 = 'trial_2'
}

/** select columns of table "mix_content_tag_enum" */
export enum Mix_Content_Tag_Enum_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_content_tag_enum" */
export enum Mix_Content_Tag_Enum_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** select columns of table "mix_content_tag" */
export enum Mix_Content_Tag_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Reviewer = 'reviewer',
  /** column name */
  Tag = 'tag'
}

/** update columns of table "mix_content_tag" */
export enum Mix_Content_Tag_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Reviewer = 'reviewer',
  /** column name */
  Tag = 'tag'
}

/** update columns of table "mix_content" */
export enum Mix_Content_Update_Column {
  /** column name */
  Abstractcontents = 'abstractcontents',
  /** column name */
  Author = 'author',
  /** column name */
  Authorname = 'authorname',
  /** column name */
  Category = 'category',
  /** column name */
  Contentid = 'contentid',
  /** column name */
  CoverImgurl = 'cover_imgurl',
  /** column name */
  DefaultProductId = 'default_product_id',
  /** column name */
  Id = 'id',
  /** column name */
  Imgurl = 'imgurl',
  /** column name */
  Offlineapplyurl = 'offlineapplyurl',
  /** column name */
  Offlinetime = 'offlinetime',
  /** column name */
  Originalurl = 'originalurl',
  /** column name */
  Pdfpagecount = 'pdfpagecount',
  /** column name */
  Pdfurl = 'pdfurl',
  /** column name */
  Price = 'price',
  /** column name */
  Readtime = 'readtime',
  /** column name */
  Recommendorder = 'recommendorder',
  /** column name */
  Redirecturl = 'redirecturl',
  /** column name */
  Reviewer = 'reviewer',
  /** column name */
  Reviewtime = 'reviewtime',
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Title = 'title',
  /** column name */
  Updatetime = 'updatetime'
}

/** unique or primary key constraints on table "mix_content_view" */
export enum Mix_Content_View_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixContentViewPkey = 'mix_content_view_pkey'
}

/** select columns of table "mix_content_view" */
export enum Mix_Content_View_Select_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Createtime = 'createtime',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source',
  /** column name */
  Userid = 'userid'
}

/** update columns of table "mix_content_view" */
export enum Mix_Content_View_Update_Column {
  /** column name */
  Contentid = 'contentid',
  /** column name */
  Createtime = 'createtime',
  /** column name */
  Id = 'id',
  /** column name */
  Source = 'source',
  /** column name */
  Userid = 'userid'
}

/** unique or primary key constraints on table "mix_crawler_daily_result" */
export enum Mix_Crawler_Daily_Result_Constraint {
  /** unique or primary key constraint on columns "updatedate", "source" */
  MixCrawlerDailyResultPkey = 'mix_crawler_daily_result_pkey'
}

/** select columns of table "mix_crawler_daily_result" */
export enum Mix_Crawler_Daily_Result_Select_Column {
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Updatedate = 'updatedate'
}

/** unique or primary key constraints on table "mix_crawler_daily_result_status" */
export enum Mix_Crawler_Daily_Result_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  MixCrawlerResultStatusPkey = 'mix_crawler_result_status_pkey'
}

export enum Mix_Crawler_Daily_Result_Status_Enum {
  /** 실패 */
  Failed = 'FAILED',
  /** 성공 */
  Success = 'SUCCESS'
}

/** select columns of table "mix_crawler_daily_result_status" */
export enum Mix_Crawler_Daily_Result_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_crawler_daily_result_status" */
export enum Mix_Crawler_Daily_Result_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "mix_crawler_daily_result" */
export enum Mix_Crawler_Daily_Result_Update_Column {
  /** column name */
  Source = 'source',
  /** column name */
  Status = 'status',
  /** column name */
  Updatedate = 'updatedate'
}

/** select columns of table "mix_feature_flag_active" */
export enum Mix_Feature_Flag_Active_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rules = 'rules'
}

/** unique or primary key constraints on table "mix_feature_flag_audit" */
export enum Mix_Feature_Flag_Audit_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixFeatureFlagAuditPkey = 'mix_feature_flag_audit_pkey'
}

/** select columns of table "mix_feature_flag_audit" */
export enum Mix_Feature_Flag_Audit_Select_Column {
  /** column name */
  ChangeReason = 'change_reason',
  /** column name */
  ChangedBy = 'changed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  FlagName = 'flag_name',
  /** column name */
  Id = 'id',
  /** column name */
  NewEnabled = 'new_enabled',
  /** column name */
  NewRules = 'new_rules',
  /** column name */
  OldEnabled = 'old_enabled',
  /** column name */
  OldRules = 'old_rules'
}

/** select "mix_feature_flag_audit_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_feature_flag_audit" */
export enum Mix_Feature_Flag_Audit_Select_Column_Mix_Feature_Flag_Audit_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  NewEnabled = 'new_enabled',
  /** column name */
  OldEnabled = 'old_enabled'
}

/** select "mix_feature_flag_audit_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_feature_flag_audit" */
export enum Mix_Feature_Flag_Audit_Select_Column_Mix_Feature_Flag_Audit_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  NewEnabled = 'new_enabled',
  /** column name */
  OldEnabled = 'old_enabled'
}

/** update columns of table "mix_feature_flag_audit" */
export enum Mix_Feature_Flag_Audit_Update_Column {
  /** column name */
  ChangeReason = 'change_reason',
  /** column name */
  ChangedBy = 'changed_by',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  FlagId = 'flag_id',
  /** column name */
  FlagName = 'flag_name',
  /** column name */
  Id = 'id',
  /** column name */
  NewEnabled = 'new_enabled',
  /** column name */
  NewRules = 'new_rules',
  /** column name */
  OldEnabled = 'old_enabled',
  /** column name */
  OldRules = 'old_rules'
}

/** unique or primary key constraints on table "mix_feature_flag" */
export enum Mix_Feature_Flag_Constraint {
  /** unique or primary key constraint on columns "name" */
  MixFeatureFlagNameKey = 'mix_feature_flag_name_key',
  /** unique or primary key constraint on columns "id" */
  MixFeatureFlagPkey = 'mix_feature_flag_pkey'
}

/** select columns of table "mix_feature_flag" */
export enum Mix_Feature_Flag_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rules = 'rules',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** select "mix_feature_flag_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_feature_flag" */
export enum Mix_Feature_Flag_Select_Column_Mix_Feature_Flag_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** select "mix_feature_flag_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_feature_flag" */
export enum Mix_Feature_Flag_Select_Column_Mix_Feature_Flag_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Enabled = 'enabled'
}

/** update columns of table "mix_feature_flag" */
export enum Mix_Feature_Flag_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rules = 'rules',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedBy = 'updated_by'
}

/** unique or primary key constraints on table "mix_last_content" */
export enum Mix_Last_Content_Constraint {
  /** unique or primary key constraint on columns "author", "source" */
  MixLastContentPkey = 'mix_last_content_pkey'
}

/** select columns of table "mix_last_content" */
export enum Mix_Last_Content_Select_Column {
  /** column name */
  Author = 'author',
  /** column name */
  Originalurl = 'originalurl',
  /** column name */
  Source = 'source',
  /** column name */
  Updatetime = 'updatetime'
}

/** update columns of table "mix_last_content" */
export enum Mix_Last_Content_Update_Column {
  /** column name */
  Author = 'author',
  /** column name */
  Originalurl = 'originalurl',
  /** column name */
  Source = 'source',
  /** column name */
  Updatetime = 'updatetime'
}

/** unique or primary key constraints on table "mix_notices" */
export enum Mix_Notices_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixNoticesPkey = 'mix_notices_pkey'
}

/** select columns of table "mix_notices" */
export enum Mix_Notices_Select_Column {
  /** column name */
  Content = 'content',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  TargetUrl = 'target_url',
  /** column name */
  Type = 'type'
}

/** update columns of table "mix_notices" */
export enum Mix_Notices_Update_Column {
  /** column name */
  Content = 'content',
  /** column name */
  EndAt = 'end_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsActive = 'is_active',
  /** column name */
  StartAt = 'start_at',
  /** column name */
  TargetUrl = 'target_url',
  /** column name */
  Type = 'type'
}

/** unique or primary key constraints on table "mix_source_info" */
export enum Mix_Source_Info_Constraint {
  /** unique or primary key constraint on columns "source" */
  MixSourceEnumPkey = 'mix_source_enum_pkey'
}

/** select columns of table "mix_source_info" */
export enum Mix_Source_Info_Select_Column {
  /** column name */
  Createdby = 'createdby',
  /** column name */
  Imgurl = 'imgurl',
  /** column name */
  Source = 'source',
  /** column name */
  Sourcename = 'sourcename'
}

/** update columns of table "mix_source_info" */
export enum Mix_Source_Info_Update_Column {
  /** column name */
  Createdby = 'createdby',
  /** column name */
  Imgurl = 'imgurl',
  /** column name */
  Source = 'source',
  /** column name */
  Sourcename = 'sourcename'
}

/** unique or primary key constraints on table "mix_user" */
export enum Mix_User_Constraint {
  /** unique or primary key constraint on columns "email", "method" */
  MixUserEmailMethodKey = 'mix_user_email_method_key',
  /** unique or primary key constraint on columns "id" */
  MixUserPkey = 'mix_user_pkey'
}

/** unique or primary key constraints on table "mix_user_groups" */
export enum Mix_User_Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixUserGroupsPkey = 'mix_user_groups_pkey'
}

/** select columns of table "mix_user_groups" */
export enum Mix_User_Groups_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

/** update columns of table "mix_user_groups" */
export enum Mix_User_Groups_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label'
}

/** unique or primary key constraints on table "mix_user_interest_tag" */
export enum Mix_User_Interest_Tag_Constraint {
  /** unique or primary key constraint on columns "user_id", "tag_value" */
  MixUserInterestTagPkey = 'mix_user_interest_tag_pkey',
  /** unique or primary key constraint on columns "user_id", "priority" */
  MixUserInterestTagUserIdPriorityKey = 'mix_user_interest_tag_user_id_priority_key'
}

/** select columns of table "mix_user_interest_tag" */
export enum Mix_User_Interest_Tag_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  TagValue = 'tag_value',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "mix_user_interest_tag" */
export enum Mix_User_Interest_Tag_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Priority = 'priority',
  /** column name */
  TagValue = 'tag_value',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select columns of table "mix_user" */
export enum Mix_User_Select_Column {
  /** column name */
  Career = 'career',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HasLmsAccess = 'has_lms_access',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position',
  /** column name */
  ProfileImg = 'profileImg',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  RefreshTokenExpiry = 'refreshTokenExpiry',
  /** column name */
  SubscribeEmail = 'subscribeEmail',
  /** column name */
  UseChromeSearch = 'use_chrome_search',
  /** column name */
  UseChromeShortcut = 'use_chrome_shortcut'
}

/** select "mix_user_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_user" */
export enum Mix_User_Select_Column_Mix_User_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  HasLmsAccess = 'has_lms_access',
  /** column name */
  SubscribeEmail = 'subscribeEmail',
  /** column name */
  UseChromeSearch = 'use_chrome_search',
  /** column name */
  UseChromeShortcut = 'use_chrome_shortcut'
}

/** select "mix_user_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_user" */
export enum Mix_User_Select_Column_Mix_User_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  HasLmsAccess = 'has_lms_access',
  /** column name */
  SubscribeEmail = 'subscribeEmail',
  /** column name */
  UseChromeSearch = 'use_chrome_search',
  /** column name */
  UseChromeShortcut = 'use_chrome_shortcut'
}

/** update columns of table "mix_user" */
export enum Mix_User_Update_Column {
  /** column name */
  Career = 'career',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  GroupId = 'group_id',
  /** column name */
  HasLmsAccess = 'has_lms_access',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Name = 'name',
  /** column name */
  Position = 'position',
  /** column name */
  ProfileImg = 'profileImg',
  /** column name */
  RefreshToken = 'refreshToken',
  /** column name */
  RefreshTokenExpiry = 'refreshTokenExpiry',
  /** column name */
  SubscribeEmail = 'subscribeEmail',
  /** column name */
  UseChromeSearch = 'use_chrome_search',
  /** column name */
  UseChromeShortcut = 'use_chrome_shortcut'
}

/** select columns of table "mix_user_view" */
export enum Mix_User_View_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  LastContentViewTime = 'last_content_view_time',
  /** column name */
  SumContentView = 'sum_content_view',
  /** column name */
  VisitCount = 'visit_count'
}

/** unique or primary key constraints on table "mix_user_vote_comment" */
export enum Mix_User_Vote_Comment_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixUserVoteCommentPkey = 'mix_user_vote_comment_pkey'
}

/** unique or primary key constraints on table "mix_user_vote_comment_reaction" */
export enum Mix_User_Vote_Comment_Reaction_Constraint {
  /** unique or primary key constraint on columns "user_id", "comment_id" */
  MixUserVoteCommentReactionCommentIdUserIdKey = 'mix_user_vote_comment_reaction_comment_id_user_id_key',
  /** unique or primary key constraint on columns "id" */
  MixUserVoteCommentReactionPkey = 'mix_user_vote_comment_reaction_pkey'
}

/** select columns of table "mix_user_vote_comment_reaction_count" */
export enum Mix_User_Vote_Comment_Reaction_Count_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  ReactionCount = 'reaction_count',
  /** column name */
  ReactionType = 'reaction_type'
}

/** select columns of table "mix_user_vote_comment_reaction" */
export enum Mix_User_Vote_Comment_Reaction_Select_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReactionType = 'reaction_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** update columns of table "mix_user_vote_comment_reaction" */
export enum Mix_User_Vote_Comment_Reaction_Update_Column {
  /** column name */
  CommentId = 'comment_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ReactionType = 'reaction_type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id'
}

/** select columns of table "mix_user_vote_comment" */
export enum Mix_User_Vote_Comment_Select_Column {
  /** column name */
  AnonymousAvatarSeed = 'anonymous_avatar_seed',
  /** column name */
  AnonymousNickname = 'anonymous_nickname',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  ReactionCount = 'reaction_count',
  /** column name */
  ReplyCount = 'reply_count',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VoteId = 'vote_id'
}

/** select "mix_user_vote_comment_aggregate_bool_exp_bool_and_arguments_columns" columns of table "mix_user_vote_comment" */
export enum Mix_User_Vote_Comment_Select_Column_Mix_User_Vote_Comment_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAnonymous = 'is_anonymous'
}

/** select "mix_user_vote_comment_aggregate_bool_exp_bool_or_arguments_columns" columns of table "mix_user_vote_comment" */
export enum Mix_User_Vote_Comment_Select_Column_Mix_User_Vote_Comment_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAnonymous = 'is_anonymous'
}

/** update columns of table "mix_user_vote_comment" */
export enum Mix_User_Vote_Comment_Update_Column {
  /** column name */
  AnonymousAvatarSeed = 'anonymous_avatar_seed',
  /** column name */
  AnonymousNickname = 'anonymous_nickname',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  IsAnonymous = 'is_anonymous',
  /** column name */
  ParentCommentId = 'parent_comment_id',
  /** column name */
  ReactionCount = 'reaction_count',
  /** column name */
  ReplyCount = 'reply_count',
  /** column name */
  Text = 'text',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VoteId = 'vote_id'
}

/** unique or primary key constraints on table "mix_user_vote" */
export enum Mix_User_Vote_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixUserVotePkey = 'mix_user_vote_pkey',
  /** unique or primary key constraint on columns "user_id", "vote_id" */
  MixUserVoteVoteIdUserIdKey = 'mix_user_vote_vote_id_user_id_key'
}

/** select columns of table "mix_user_vote_count" */
export enum Mix_User_Vote_Count_Select_Column {
  /** column name */
  Percentage = 'percentage',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  VoteCount = 'vote_count',
  /** column name */
  VoteId = 'vote_id'
}

/** select columns of table "mix_user_vote" */
export enum Mix_User_Vote_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VoteId = 'vote_id'
}

/** update columns of table "mix_user_vote" */
export enum Mix_User_Vote_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  SelectedOption = 'selected_option',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UserId = 'user_id',
  /** column name */
  VoteId = 'vote_id'
}

/** unique or primary key constraints on table "mix_vote" */
export enum Mix_Vote_Constraint {
  /** unique or primary key constraint on columns "id" */
  MixVotePkey = 'mix_vote_pkey'
}

/** select columns of table "mix_vote" */
export enum Mix_Vote_Select_Column {
  /** column name */
  ContentIds = 'content_ids',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FirstImage = 'first_image',
  /** column name */
  FirstOption = 'first_option',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  SecondImage = 'second_image',
  /** column name */
  SecondOption = 'second_option',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** update columns of table "mix_vote" */
export enum Mix_Vote_Update_Column {
  /** column name */
  ContentIds = 'content_ids',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  Description = 'description',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  FirstImage = 'first_image',
  /** column name */
  FirstOption = 'first_option',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  SecondImage = 'second_image',
  /** column name */
  SecondOption = 'second_option',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** unique or primary key constraints on table "offline_attendee" */
export enum Offline_Attendee_Constraint {
  /** unique or primary key constraint on columns "phone", "order_id" */
  OfflineAttendeeOrderIdPhoneKey = 'offline_attendee_order_id_phone_key',
  /** unique or primary key constraint on columns "id" */
  OfflineAttendeePkey = 'offline_attendee_pkey'
}

/** select columns of table "offline_attendee_enrolled_view_free" */
export enum Offline_Attendee_Enrolled_View_Free_Select_Column {
  /** column name */
  AdvanceQuestion = 'advance_question',
  /** column name */
  Career = 'career',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InterestCategory = 'interest_category',
  /** column name */
  IsVipNetworkingEnrolled = 'is_vip_networking_enrolled',
  /** column name */
  Name = 'name',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrderName = 'order_name',
  /** column name */
  OrderStatus = 'order_status',
  /** column name */
  Phone = 'phone',
  /** column name */
  Position = 'position',
  /** column name */
  TeamAndRole = 'team_and_role',
  /** column name */
  TotalAmount = 'total_amount'
}

/** select columns of table "offline_attendee_enrolled_view" */
export enum Offline_Attendee_Enrolled_View_Select_Column {
  /** column name */
  AdvanceQuestion = 'advance_question',
  /** column name */
  Career = 'career',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InterestCategory = 'interest_category',
  /** column name */
  IsVipNetworkingEnrolled = 'is_vip_networking_enrolled',
  /** column name */
  Name = 'name',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  OrderName = 'order_name',
  /** column name */
  OrderStatus = 'order_status',
  /** column name */
  Phone = 'phone',
  /** column name */
  Position = 'position',
  /** column name */
  TeamAndRole = 'team_and_role',
  /** column name */
  TotalAmount = 'total_amount'
}

/** select columns of table "offline_attendee" */
export enum Offline_Attendee_Select_Column {
  /** column name */
  AdvanceQuestion = 'advance_question',
  /** column name */
  Career = 'career',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InterestCategory = 'interest_category',
  /** column name */
  IsVipNetworkingEnrolled = 'is_vip_networking_enrolled',
  /** column name */
  Name = 'name',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Position = 'position',
  /** column name */
  TeamAndRole = 'team_and_role'
}

/** select "offline_attendee_aggregate_bool_exp_bool_and_arguments_columns" columns of table "offline_attendee" */
export enum Offline_Attendee_Select_Column_Offline_Attendee_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsVipNetworkingEnrolled = 'is_vip_networking_enrolled'
}

/** select "offline_attendee_aggregate_bool_exp_bool_or_arguments_columns" columns of table "offline_attendee" */
export enum Offline_Attendee_Select_Column_Offline_Attendee_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsVipNetworkingEnrolled = 'is_vip_networking_enrolled'
}

/** update columns of table "offline_attendee" */
export enum Offline_Attendee_Update_Column {
  /** column name */
  AdvanceQuestion = 'advance_question',
  /** column name */
  Career = 'career',
  /** column name */
  Company = 'company',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  InterestCategory = 'interest_category',
  /** column name */
  IsVipNetworkingEnrolled = 'is_vip_networking_enrolled',
  /** column name */
  Name = 'name',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Phone = 'phone',
  /** column name */
  Position = 'position',
  /** column name */
  TeamAndRole = 'team_and_role'
}

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** unique or primary key constraints on table "order" */
export enum Order_Constraint {
  /** unique or primary key constraint on columns "order_token" */
  OrderOrderTokenKey = 'order_order_token_key',
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey'
}

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  DiscountApply = 'discount_apply',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Name = 'name',
  /** column name */
  OrderToken = 'order_token',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount'
}

/** unique or primary key constraints on table "order_status" */
export enum Order_Status_Constraint {
  /** unique or primary key constraint on columns "value" */
  OrderStatusPkey = 'order_status_pkey'
}

export enum Order_Status_Enum {
  /** 승인 실패 */
  Aborted = 'ABORTED',
  /** 취소 완료 */
  Canceled = 'CANCELED',
  /** 결제 완료 */
  Done = 'DONE',
  /** 시간 만료 */
  Expired = 'EXPIRED',
  /** 승인 대기 */
  InProgress = 'IN_PROGRESS',
  /** 부분 취소 */
  PartialCanceled = 'PARTIAL_CANCELED',
  /** 미결제 */
  Ready = 'READY',
  /** 취소 대기 */
  WaitingForCanceled = 'WAITING_FOR_CANCELED',
  /** 입금 대기 */
  WaitingForDeposit = 'WAITING_FOR_DEPOSIT'
}

/** select columns of table "order_status" */
export enum Order_Status_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "order_status" */
export enum Order_Status_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** update columns of table "order" */
export enum Order_Update_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  DiscountApply = 'discount_apply',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Name = 'name',
  /** column name */
  OrderToken = 'order_token',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount'
}

/** select columns of table "orders_created_at_view" */
export enum Orders_Created_At_View_Select_Column {
  /** column name */
  ApprovedAt = 'approved_at',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CustomerEmail = 'customer_email',
  /** column name */
  CustomerId = 'customer_id',
  /** column name */
  CustomerName = 'customer_name',
  /** column name */
  DiscountApply = 'discount_apply',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Name = 'name',
  /** column name */
  OrderToken = 'order_token',
  /** column name */
  ProductId = 'product_id',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  RequestedAt = 'requested_at',
  /** column name */
  Status = 'status',
  /** column name */
  TotalAmount = 'total_amount'
}

/** unique or primary key constraints on table "product" */
export enum Product_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProductPkey = 'product_pkey'
}

/** select columns of table "product" */
export enum Product_Select_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DiscountEndTime = 'discount_end_time',
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  DiscountStartTime = 'discount_start_time',
  /** column name */
  DiscountStock = 'discount_stock',
  /** column name */
  Id = 'id',
  /** column name */
  IsGuestPaymentAllowed = 'is_guest_payment_allowed',
  /** column name */
  OrderEndTime = 'order_end_time',
  /** column name */
  Price = 'price',
  /** column name */
  Stock = 'stock'
}

/** select "product_aggregate_bool_exp_avg_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_bool_and_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsGuestPaymentAllowed = 'is_guest_payment_allowed'
}

/** select "product_aggregate_bool_exp_bool_or_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsGuestPaymentAllowed = 'is_guest_payment_allowed'
}

/** select "product_aggregate_bool_exp_corr_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_max_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_min_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_sum_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** select "product_aggregate_bool_exp_var_samp_arguments_columns" columns of table "product" */
export enum Product_Select_Column_Product_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  Price = 'price'
}

/** update columns of table "product" */
export enum Product_Update_Column {
  /** column name */
  ContentId = 'content_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedBy = 'created_by',
  /** column name */
  DiscountEndTime = 'discount_end_time',
  /** column name */
  DiscountPrice = 'discount_price',
  /** column name */
  DiscountStartTime = 'discount_start_time',
  /** column name */
  DiscountStock = 'discount_stock',
  /** column name */
  Id = 'id',
  /** column name */
  IsGuestPaymentAllowed = 'is_guest_payment_allowed',
  /** column name */
  OrderEndTime = 'order_end_time',
  /** column name */
  Price = 'price',
  /** column name */
  Stock = 'stock'
}

/** unique or primary key constraints on table "toss_payments_org_code" */
export enum Toss_Payments_Org_Code_Constraint {
  /** unique or primary key constraint on columns "code_num", "code_eng" */
  TossPaymentsOrgCodeCodeNumCodeEngKey = 'toss_payments_org_code_code_num_code_eng_key',
  /** unique or primary key constraint on columns "id" */
  TossPaymentsOrgCodePkey = 'toss_payments_org_code_pkey'
}

/** select columns of table "toss_payments_org_code" */
export enum Toss_Payments_Org_Code_Select_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CodeEng = 'code_eng',
  /** column name */
  CodeKor = 'code_kor',
  /** column name */
  CodeNum = 'code_num',
  /** column name */
  Id = 'id',
  /** column name */
  Organization = 'organization',
  /** column name */
  TossUpdateDate = 'toss_update_date'
}

/** update columns of table "toss_payments_org_code" */
export enum Toss_Payments_Org_Code_Update_Column {
  /** column name */
  Category = 'category',
  /** column name */
  CodeEng = 'code_eng',
  /** column name */
  CodeKor = 'code_kor',
  /** column name */
  CodeNum = 'code_num',
  /** column name */
  Id = 'id',
  /** column name */
  Organization = 'organization',
  /** column name */
  TossUpdateDate = 'toss_update_date'
}

export const MixClassCourseFragmentDoc = gql`
    fragment mixClassCourse on mix_class_course {
  id
  title
  instructor_name
  thumbnail_url
  description
  is_active
  total_lectures
  created_at
  updated_at
}
    `;
export const Mix_Class_LectureFragmentDoc = gql`
    fragment mix_class_lecture on mix_class_lecture {
  id
  course_id
  title
  video_url
  duration
  lecture_order
  has_materials
  created_at
  updated_at
}
    `;
export const ProductFragmentDoc = gql`
    fragment product on product {
  id
  content_id
  price
  discount_price
  discount_start_time
  discount_end_time
  discount_amount
  created_at
  order_end_time
  is_default
  is_guest_payment_allowed
  on_order
  on_discount
  mix_content {
    id
    title
    abstractcontents
    category
    authorname
    imgurl
    updatetime
    offlinetime
    readtime
    default_product_id
  }
}
    `;
export const Mix_ContentFragmentDoc = gql`
    fragment mix_content on mix_content {
  id
  authorname
  abstractcontents
  author
  contentid
  imgurl
  cover_imgurl
  originalurl
  redirecturl
  source
  title
  category
  readtime
  updatetime
  updatedate
  recommendorder
  pdfurl
  pdfpagecount
  offlinetime
  default_product_id
  bookmarked
  isoriginal
  isrecommend
  released
  mix_source_info {
    imgurl
  }
  mix_content_tags {
    mix_content_tag_enum {
      value
      comment
    }
  }
  products {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export const Mix_UserFragmentDoc = gql`
    fragment mix_user on mix_user {
  id
  email
  name
  profileImg
  position
  career
  createdAt
  subscribeEmail
  method
  use_chrome_search
  use_chrome_shortcut
  has_lms_access
  group_id
}
    `;
export const Offline_AttendeeFragmentDoc = gql`
    fragment offline_attendee on offline_attendee {
  id
  order_id
  email
  name
  phone
  company
  position
  career
  advance_question
  team_and_role
  interest_category
  is_vip_networking_enrolled
}
    `;
export const OrderFragmentDoc = gql`
    fragment order on order {
  id
  customer_id
  customer_name
  customer_email
  product_id
  name
  total_amount
  method
  status
  created_at
  requested_at
  approved_at
  quantity
  discount_apply
  order_token
  product {
    ...product
  }
  offline_attendees {
    ...offline_attendee
  }
}
    ${ProductFragmentDoc}
${Offline_AttendeeFragmentDoc}`;
export const CommentFieldsFragmentDoc = gql`
    fragment CommentFields on mix_user_vote_comment {
  id
  text
  created_at
  is_anonymous
  anonymous_nickname
  anonymous_avatar_seed
  parent_comment_id
  reply_count
  reaction_count
  mix_user {
    id
    name
    profileImg
  }
}
    `;
export const AllTimePopularContentsDocument = gql`
    query AllTimePopularContents($limit: Int = 10, $minViews: bigint = 10, $dataSources: [String!] = ["web", "extension", "ga4"]) {
  mix_content_popular_all_time(
    where: {view_count: {_gte: $minViews}, data_source: {_in: $dataSources}}
    order_by: {view_count: desc}
    limit: $limit
  ) {
    id
    content_id
    view_count
    data_source
    last_updated
    created_at
    content {
      ...mix_content
    }
  }
}
    ${Mix_ContentFragmentDoc}`;
export type AllTimePopularContentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables>, 'query'>;

    export const AllTimePopularContentsComponent = (props: AllTimePopularContentsComponentProps) => (
      <ApolloReactComponents.Query<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables> query={AllTimePopularContentsDocument} {...props} />
    );
    

/**
 * __useAllTimePopularContentsQuery__
 *
 * To run a query within a React component, call `useAllTimePopularContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTimePopularContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTimePopularContentsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      minViews: // value for 'minViews'
 *      dataSources: // value for 'dataSources'
 *   },
 * });
 */
export function useAllTimePopularContentsQuery(baseOptions?: Apollo.QueryHookOptions<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables>(AllTimePopularContentsDocument, options);
      }
export function useAllTimePopularContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables>(AllTimePopularContentsDocument, options);
        }
export type AllTimePopularContentsQueryHookResult = ReturnType<typeof useAllTimePopularContentsQuery>;
export type AllTimePopularContentsLazyQueryHookResult = ReturnType<typeof useAllTimePopularContentsLazyQuery>;
export type AllTimePopularContentsQueryResult = Apollo.QueryResult<AllTimePopularContentsQuery, AllTimePopularContentsQueryVariables>;
export const InsertArchiveBookmarkDocument = gql`
    mutation insertArchiveBookmark($archiveId: uuid!) {
  insert_mix_archive_bookmark_one(object: {archiveid: $archiveId}) {
    id
    archiveid
    userid
  }
}
    `;
export type InsertArchiveBookmarkMutationFn = Apollo.MutationFunction<InsertArchiveBookmarkMutation, InsertArchiveBookmarkMutationVariables>;
export type InsertArchiveBookmarkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertArchiveBookmarkMutation, InsertArchiveBookmarkMutationVariables>, 'mutation'>;

    export const InsertArchiveBookmarkComponent = (props: InsertArchiveBookmarkComponentProps) => (
      <ApolloReactComponents.Mutation<InsertArchiveBookmarkMutation, InsertArchiveBookmarkMutationVariables> mutation={InsertArchiveBookmarkDocument} {...props} />
    );
    

/**
 * __useInsertArchiveBookmarkMutation__
 *
 * To run a mutation, you first call `useInsertArchiveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertArchiveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertArchiveBookmarkMutation, { data, loading, error }] = useInsertArchiveBookmarkMutation({
 *   variables: {
 *      archiveId: // value for 'archiveId'
 *   },
 * });
 */
export function useInsertArchiveBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<InsertArchiveBookmarkMutation, InsertArchiveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertArchiveBookmarkMutation, InsertArchiveBookmarkMutationVariables>(InsertArchiveBookmarkDocument, options);
      }
export type InsertArchiveBookmarkMutationHookResult = ReturnType<typeof useInsertArchiveBookmarkMutation>;
export type InsertArchiveBookmarkMutationResult = Apollo.MutationResult<InsertArchiveBookmarkMutation>;
export type InsertArchiveBookmarkMutationOptions = Apollo.BaseMutationOptions<InsertArchiveBookmarkMutation, InsertArchiveBookmarkMutationVariables>;
export const DeleteArchiveBookmarkDocument = gql`
    mutation deleteArchiveBookmark($archiveId: uuid!) {
  delete_mix_archive_bookmark(where: {archiveid: {_eq: $archiveId}}) {
    affected_rows
  }
}
    `;
export type DeleteArchiveBookmarkMutationFn = Apollo.MutationFunction<DeleteArchiveBookmarkMutation, DeleteArchiveBookmarkMutationVariables>;
export type DeleteArchiveBookmarkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteArchiveBookmarkMutation, DeleteArchiveBookmarkMutationVariables>, 'mutation'>;

    export const DeleteArchiveBookmarkComponent = (props: DeleteArchiveBookmarkComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteArchiveBookmarkMutation, DeleteArchiveBookmarkMutationVariables> mutation={DeleteArchiveBookmarkDocument} {...props} />
    );
    

/**
 * __useDeleteArchiveBookmarkMutation__
 *
 * To run a mutation, you first call `useDeleteArchiveBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteArchiveBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteArchiveBookmarkMutation, { data, loading, error }] = useDeleteArchiveBookmarkMutation({
 *   variables: {
 *      archiveId: // value for 'archiveId'
 *   },
 * });
 */
export function useDeleteArchiveBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteArchiveBookmarkMutation, DeleteArchiveBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteArchiveBookmarkMutation, DeleteArchiveBookmarkMutationVariables>(DeleteArchiveBookmarkDocument, options);
      }
export type DeleteArchiveBookmarkMutationHookResult = ReturnType<typeof useDeleteArchiveBookmarkMutation>;
export type DeleteArchiveBookmarkMutationResult = Apollo.MutationResult<DeleteArchiveBookmarkMutation>;
export type DeleteArchiveBookmarkMutationOptions = Apollo.BaseMutationOptions<DeleteArchiveBookmarkMutation, DeleteArchiveBookmarkMutationVariables>;
export const ArchiveBookmarksDocument = gql`
    query archiveBookmarks($userId: uuid!, $limit: Int, $offset: Int) {
  mix_archive_bookmark(
    where: {userid: {_eq: $userId}}
    limit: $limit
    offset: $offset
    order_by: {updatetime: desc}
  ) {
    id
    archiveid
    updatetime
    mix_archive {
      id
      title
      source
      sourcename
      mix_archive_sourcename {
        imgurl
        source
        sourcename
      }
      view_url
      download_url
      thumbnail_url
      tags
      created_at
      updated_at
    }
  }
}
    `;
export type ArchiveBookmarksComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables>, 'query'> & ({ variables: ArchiveBookmarksQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ArchiveBookmarksComponent = (props: ArchiveBookmarksComponentProps) => (
      <ApolloReactComponents.Query<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables> query={ArchiveBookmarksDocument} {...props} />
    );
    

/**
 * __useArchiveBookmarksQuery__
 *
 * To run a query within a React component, call `useArchiveBookmarksQuery` and pass it any options that fit your needs.
 * When your component renders, `useArchiveBookmarksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useArchiveBookmarksQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useArchiveBookmarksQuery(baseOptions: Apollo.QueryHookOptions<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables>(ArchiveBookmarksDocument, options);
      }
export function useArchiveBookmarksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables>(ArchiveBookmarksDocument, options);
        }
export type ArchiveBookmarksQueryHookResult = ReturnType<typeof useArchiveBookmarksQuery>;
export type ArchiveBookmarksLazyQueryHookResult = ReturnType<typeof useArchiveBookmarksLazyQuery>;
export type ArchiveBookmarksQueryResult = Apollo.QueryResult<ArchiveBookmarksQuery, ArchiveBookmarksQueryVariables>;
export const BookmarkDocument = gql`
    query bookmark($userId: uuid!, $limit: Int, $offset: Int) {
  mix_content_bookmark(
    where: {userid: {_eq: $userId}}
    limit: $limit
    offset: $offset
    order_by: {updatetime: desc}
  ) {
    id
    mix_content {
      ...mix_content
    }
  }
}
    ${Mix_ContentFragmentDoc}`;
export type BookmarkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BookmarkQuery, BookmarkQueryVariables>, 'query'> & ({ variables: BookmarkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BookmarkComponent = (props: BookmarkComponentProps) => (
      <ApolloReactComponents.Query<BookmarkQuery, BookmarkQueryVariables> query={BookmarkDocument} {...props} />
    );
    

/**
 * __useBookmarkQuery__
 *
 * To run a query within a React component, call `useBookmarkQuery` and pass it any options that fit your needs.
 * When your component renders, `useBookmarkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBookmarkQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useBookmarkQuery(baseOptions: Apollo.QueryHookOptions<BookmarkQuery, BookmarkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BookmarkQuery, BookmarkQueryVariables>(BookmarkDocument, options);
      }
export function useBookmarkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BookmarkQuery, BookmarkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BookmarkQuery, BookmarkQueryVariables>(BookmarkDocument, options);
        }
export type BookmarkQueryHookResult = ReturnType<typeof useBookmarkQuery>;
export type BookmarkLazyQueryHookResult = ReturnType<typeof useBookmarkLazyQuery>;
export type BookmarkQueryResult = Apollo.QueryResult<BookmarkQuery, BookmarkQueryVariables>;
export const GetContentsByIdsDocument = gql`
    query GetContentsByIds($ids: [uuid!]!) {
  mix_content(where: {id: {_in: $ids}}) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type GetContentsByIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetContentsByIdsQuery, GetContentsByIdsQueryVariables>, 'query'> & ({ variables: GetContentsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetContentsByIdsComponent = (props: GetContentsByIdsComponentProps) => (
      <ApolloReactComponents.Query<GetContentsByIdsQuery, GetContentsByIdsQueryVariables> query={GetContentsByIdsDocument} {...props} />
    );
    

/**
 * __useGetContentsByIdsQuery__
 *
 * To run a query within a React component, call `useGetContentsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentsByIdsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useGetContentsByIdsQuery(baseOptions: Apollo.QueryHookOptions<GetContentsByIdsQuery, GetContentsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContentsByIdsQuery, GetContentsByIdsQueryVariables>(GetContentsByIdsDocument, options);
      }
export function useGetContentsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContentsByIdsQuery, GetContentsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContentsByIdsQuery, GetContentsByIdsQueryVariables>(GetContentsByIdsDocument, options);
        }
export type GetContentsByIdsQueryHookResult = ReturnType<typeof useGetContentsByIdsQuery>;
export type GetContentsByIdsLazyQueryHookResult = ReturnType<typeof useGetContentsByIdsLazyQuery>;
export type GetContentsByIdsQueryResult = Apollo.QueryResult<GetContentsByIdsQuery, GetContentsByIdsQueryVariables>;
export const GetCourseProgressDocument = gql`
    query getCourseProgress($userId: uuid!, $courseId: Int!) {
  mix_class_course_progress(
    where: {user_id: {_eq: $userId}, course_id: {_eq: $courseId}}
  ) {
    id
    user_id
    course_id
    status
    progress
    start_date
    end_date
    last_watched
    created_at
    updated_at
  }
}
    `;
export type GetCourseProgressComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>, 'query'> & ({ variables: GetCourseProgressQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCourseProgressComponent = (props: GetCourseProgressComponentProps) => (
      <ApolloReactComponents.Query<GetCourseProgressQuery, GetCourseProgressQueryVariables> query={GetCourseProgressDocument} {...props} />
    );
    

/**
 * __useGetCourseProgressQuery__
 *
 * To run a query within a React component, call `useGetCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCourseProgressQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useGetCourseProgressQuery(baseOptions: Apollo.QueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
      }
export function useGetCourseProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCourseProgressQuery, GetCourseProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCourseProgressQuery, GetCourseProgressQueryVariables>(GetCourseProgressDocument, options);
        }
export type GetCourseProgressQueryHookResult = ReturnType<typeof useGetCourseProgressQuery>;
export type GetCourseProgressLazyQueryHookResult = ReturnType<typeof useGetCourseProgressLazyQuery>;
export type GetCourseProgressQueryResult = Apollo.QueryResult<GetCourseProgressQuery, GetCourseProgressQueryVariables>;
export const UpsertCourseProgressDocument = gql`
    mutation upsertCourseProgress($object: mix_class_course_progress_insert_input!, $on_conflict: mix_class_course_progress_on_conflict!) {
  insert_mix_class_course_progress_one(object: $object, on_conflict: $on_conflict) {
    id
    user_id
    course_id
    status
    progress
    start_date
    end_date
    last_watched
    created_at
    updated_at
  }
}
    `;
export type UpsertCourseProgressMutationFn = Apollo.MutationFunction<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>;
export type UpsertCourseProgressComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>, 'mutation'>;

    export const UpsertCourseProgressComponent = (props: UpsertCourseProgressComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables> mutation={UpsertCourseProgressDocument} {...props} />
    );
    

/**
 * __useUpsertCourseProgressMutation__
 *
 * To run a mutation, you first call `useUpsertCourseProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCourseProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCourseProgressMutation, { data, loading, error }] = useUpsertCourseProgressMutation({
 *   variables: {
 *      object: // value for 'object'
 *      on_conflict: // value for 'on_conflict'
 *   },
 * });
 */
export function useUpsertCourseProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>(UpsertCourseProgressDocument, options);
      }
export type UpsertCourseProgressMutationHookResult = ReturnType<typeof useUpsertCourseProgressMutation>;
export type UpsertCourseProgressMutationResult = Apollo.MutationResult<UpsertCourseProgressMutation>;
export type UpsertCourseProgressMutationOptions = Apollo.BaseMutationOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>;
export const DeleteBookmarkDocument = gql`
    mutation deleteBookmark($contentId: uuid!) {
  delete_mix_content_bookmark(where: {contentid: {_eq: $contentId}}) {
    returning {
      id
      mix_content {
        id
        bookmarked
      }
    }
  }
}
    `;
export type DeleteBookmarkMutationFn = Apollo.MutationFunction<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>;
export type DeleteBookmarkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>, 'mutation'>;

    export const DeleteBookmarkComponent = (props: DeleteBookmarkComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteBookmarkMutation, DeleteBookmarkMutationVariables> mutation={DeleteBookmarkDocument} {...props} />
    );
    

/**
 * __useDeleteBookmarkMutation__
 *
 * To run a mutation, you first call `useDeleteBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBookmarkMutation, { data, loading, error }] = useDeleteBookmarkMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useDeleteBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>(DeleteBookmarkDocument, options);
      }
export type DeleteBookmarkMutationHookResult = ReturnType<typeof useDeleteBookmarkMutation>;
export type DeleteBookmarkMutationResult = Apollo.MutationResult<DeleteBookmarkMutation>;
export type DeleteBookmarkMutationOptions = Apollo.BaseMutationOptions<DeleteBookmarkMutation, DeleteBookmarkMutationVariables>;
export const DeleteOrderDocument = gql`
    mutation deleteOrder($where: order_bool_exp!) {
  delete_order(where: $where) {
    returning {
      id
    }
  }
}
    `;
export type DeleteOrderMutationFn = Apollo.MutationFunction<DeleteOrderMutation, DeleteOrderMutationVariables>;
export type DeleteOrderComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteOrderMutation, DeleteOrderMutationVariables>, 'mutation'>;

    export const DeleteOrderComponent = (props: DeleteOrderComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteOrderMutation, DeleteOrderMutationVariables> mutation={DeleteOrderDocument} {...props} />
    );
    

/**
 * __useDeleteOrderMutation__
 *
 * To run a mutation, you first call `useDeleteOrderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteOrderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteOrderMutation, { data, loading, error }] = useDeleteOrderMutation({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useDeleteOrderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteOrderMutation, DeleteOrderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteOrderMutation, DeleteOrderMutationVariables>(DeleteOrderDocument, options);
      }
export type DeleteOrderMutationHookResult = ReturnType<typeof useDeleteOrderMutation>;
export type DeleteOrderMutationResult = Apollo.MutationResult<DeleteOrderMutation>;
export type DeleteOrderMutationOptions = Apollo.BaseMutationOptions<DeleteOrderMutation, DeleteOrderMutationVariables>;
export const DeleteUserInterestTagsDocument = gql`
    mutation deleteUserInterestTags($userId: uuid!, $tagValues: [mix_content_tag_enum_enum!]!) {
  delete_mix_user_interest_tag(
    where: {user_id: {_eq: $userId}, tag_value: {_nin: $tagValues}}
  ) {
    affected_rows
  }
}
    `;
export type DeleteUserInterestTagsMutationFn = Apollo.MutationFunction<DeleteUserInterestTagsMutation, DeleteUserInterestTagsMutationVariables>;
export type DeleteUserInterestTagsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteUserInterestTagsMutation, DeleteUserInterestTagsMutationVariables>, 'mutation'>;

    export const DeleteUserInterestTagsComponent = (props: DeleteUserInterestTagsComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteUserInterestTagsMutation, DeleteUserInterestTagsMutationVariables> mutation={DeleteUserInterestTagsDocument} {...props} />
    );
    

/**
 * __useDeleteUserInterestTagsMutation__
 *
 * To run a mutation, you first call `useDeleteUserInterestTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserInterestTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserInterestTagsMutation, { data, loading, error }] = useDeleteUserInterestTagsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      tagValues: // value for 'tagValues'
 *   },
 * });
 */
export function useDeleteUserInterestTagsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserInterestTagsMutation, DeleteUserInterestTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserInterestTagsMutation, DeleteUserInterestTagsMutationVariables>(DeleteUserInterestTagsDocument, options);
      }
export type DeleteUserInterestTagsMutationHookResult = ReturnType<typeof useDeleteUserInterestTagsMutation>;
export type DeleteUserInterestTagsMutationResult = Apollo.MutationResult<DeleteUserInterestTagsMutation>;
export type DeleteUserInterestTagsMutationOptions = Apollo.BaseMutationOptions<DeleteUserInterestTagsMutation, DeleteUserInterestTagsMutationVariables>;
export const GetFeatureFlagsDocument = gql`
    query GetFeatureFlags {
  mix_feature_flag_active {
    id
    name
    description
    enabled
    rules
    category
  }
}
    `;
export type GetFeatureFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>, 'query'>;

    export const GetFeatureFlagsComponent = (props: GetFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables> query={GetFeatureFlagsDocument} {...props} />
    );
    

/**
 * __useGetFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
      }
export function useGetFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>(GetFeatureFlagsDocument, options);
        }
export type GetFeatureFlagsQueryHookResult = ReturnType<typeof useGetFeatureFlagsQuery>;
export type GetFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsLazyQuery>;
export type GetFeatureFlagsQueryResult = Apollo.QueryResult<GetFeatureFlagsQuery, GetFeatureFlagsQueryVariables>;
export const GetAllFeatureFlagsDocument = gql`
    query GetAllFeatureFlags {
  mix_feature_flag(order_by: {category: asc, name: asc}) {
    id
    name
    description
    enabled
    rules
    category
    start_date
    end_date
    created_at
    updated_at
    created_by
    updated_by
  }
}
    `;
export type GetAllFeatureFlagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>, 'query'>;

    export const GetAllFeatureFlagsComponent = (props: GetAllFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Query<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables> query={GetAllFeatureFlagsDocument} {...props} />
    );
    

/**
 * __useGetAllFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetAllFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>(GetAllFeatureFlagsDocument, options);
      }
export function useGetAllFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>(GetAllFeatureFlagsDocument, options);
        }
export type GetAllFeatureFlagsQueryHookResult = ReturnType<typeof useGetAllFeatureFlagsQuery>;
export type GetAllFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetAllFeatureFlagsLazyQuery>;
export type GetAllFeatureFlagsQueryResult = Apollo.QueryResult<GetAllFeatureFlagsQuery, GetAllFeatureFlagsQueryVariables>;
export const GetFeatureFlagByNameDocument = gql`
    query GetFeatureFlagByName($name: String!) {
  mix_feature_flag(where: {name: {_eq: $name}}, limit: 1) {
    id
    name
    description
    enabled
    rules
    category
    start_date
    end_date
  }
}
    `;
export type GetFeatureFlagByNameComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables>, 'query'> & ({ variables: GetFeatureFlagByNameQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFeatureFlagByNameComponent = (props: GetFeatureFlagByNameComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables> query={GetFeatureFlagByNameDocument} {...props} />
    );
    

/**
 * __useGetFeatureFlagByNameQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagByNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagByNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagByNameQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFeatureFlagByNameQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables>(GetFeatureFlagByNameDocument, options);
      }
export function useGetFeatureFlagByNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables>(GetFeatureFlagByNameDocument, options);
        }
export type GetFeatureFlagByNameQueryHookResult = ReturnType<typeof useGetFeatureFlagByNameQuery>;
export type GetFeatureFlagByNameLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagByNameLazyQuery>;
export type GetFeatureFlagByNameQueryResult = Apollo.QueryResult<GetFeatureFlagByNameQuery, GetFeatureFlagByNameQueryVariables>;
export const GetFeatureFlagsByCategoryDocument = gql`
    query GetFeatureFlagsByCategory($category: String!) {
  mix_feature_flag(where: {category: {_eq: $category}}, order_by: {name: asc}) {
    id
    name
    description
    enabled
    rules
    category
  }
}
    `;
export type GetFeatureFlagsByCategoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables>, 'query'> & ({ variables: GetFeatureFlagsByCategoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFeatureFlagsByCategoryComponent = (props: GetFeatureFlagsByCategoryComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables> query={GetFeatureFlagsByCategoryDocument} {...props} />
    );
    

/**
 * __useGetFeatureFlagsByCategoryQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagsByCategoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagsByCategoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagsByCategoryQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetFeatureFlagsByCategoryQuery(baseOptions: Apollo.QueryHookOptions<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables>(GetFeatureFlagsByCategoryDocument, options);
      }
export function useGetFeatureFlagsByCategoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables>(GetFeatureFlagsByCategoryDocument, options);
        }
export type GetFeatureFlagsByCategoryQueryHookResult = ReturnType<typeof useGetFeatureFlagsByCategoryQuery>;
export type GetFeatureFlagsByCategoryLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagsByCategoryLazyQuery>;
export type GetFeatureFlagsByCategoryQueryResult = Apollo.QueryResult<GetFeatureFlagsByCategoryQuery, GetFeatureFlagsByCategoryQueryVariables>;
export const ToggleFeatureFlagDocument = gql`
    mutation ToggleFeatureFlag($id: uuid!, $enabled: Boolean!, $updatedBy: uuid) {
  update_mix_feature_flag_by_pk(
    pk_columns: {id: $id}
    _set: {enabled: $enabled, updated_by: $updatedBy}
  ) {
    id
    name
    enabled
    updated_at
  }
}
    `;
export type ToggleFeatureFlagMutationFn = Apollo.MutationFunction<ToggleFeatureFlagMutation, ToggleFeatureFlagMutationVariables>;
export type ToggleFeatureFlagComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ToggleFeatureFlagMutation, ToggleFeatureFlagMutationVariables>, 'mutation'>;

    export const ToggleFeatureFlagComponent = (props: ToggleFeatureFlagComponentProps) => (
      <ApolloReactComponents.Mutation<ToggleFeatureFlagMutation, ToggleFeatureFlagMutationVariables> mutation={ToggleFeatureFlagDocument} {...props} />
    );
    

/**
 * __useToggleFeatureFlagMutation__
 *
 * To run a mutation, you first call `useToggleFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFeatureFlagMutation, { data, loading, error }] = useToggleFeatureFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useToggleFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFeatureFlagMutation, ToggleFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFeatureFlagMutation, ToggleFeatureFlagMutationVariables>(ToggleFeatureFlagDocument, options);
      }
export type ToggleFeatureFlagMutationHookResult = ReturnType<typeof useToggleFeatureFlagMutation>;
export type ToggleFeatureFlagMutationResult = Apollo.MutationResult<ToggleFeatureFlagMutation>;
export type ToggleFeatureFlagMutationOptions = Apollo.BaseMutationOptions<ToggleFeatureFlagMutation, ToggleFeatureFlagMutationVariables>;
export const UpdateFeatureFlagRulesDocument = gql`
    mutation UpdateFeatureFlagRules($id: uuid!, $enabled: Boolean, $rules: jsonb, $updatedBy: uuid) {
  update_mix_feature_flag_by_pk(
    pk_columns: {id: $id}
    _set: {enabled: $enabled, rules: $rules, updated_by: $updatedBy}
  ) {
    id
    name
    enabled
    rules
    updated_at
  }
}
    `;
export type UpdateFeatureFlagRulesMutationFn = Apollo.MutationFunction<UpdateFeatureFlagRulesMutation, UpdateFeatureFlagRulesMutationVariables>;
export type UpdateFeatureFlagRulesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateFeatureFlagRulesMutation, UpdateFeatureFlagRulesMutationVariables>, 'mutation'>;

    export const UpdateFeatureFlagRulesComponent = (props: UpdateFeatureFlagRulesComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateFeatureFlagRulesMutation, UpdateFeatureFlagRulesMutationVariables> mutation={UpdateFeatureFlagRulesDocument} {...props} />
    );
    

/**
 * __useUpdateFeatureFlagRulesMutation__
 *
 * To run a mutation, you first call `useUpdateFeatureFlagRulesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFeatureFlagRulesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFeatureFlagRulesMutation, { data, loading, error }] = useUpdateFeatureFlagRulesMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *      rules: // value for 'rules'
 *      updatedBy: // value for 'updatedBy'
 *   },
 * });
 */
export function useUpdateFeatureFlagRulesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFeatureFlagRulesMutation, UpdateFeatureFlagRulesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFeatureFlagRulesMutation, UpdateFeatureFlagRulesMutationVariables>(UpdateFeatureFlagRulesDocument, options);
      }
export type UpdateFeatureFlagRulesMutationHookResult = ReturnType<typeof useUpdateFeatureFlagRulesMutation>;
export type UpdateFeatureFlagRulesMutationResult = Apollo.MutationResult<UpdateFeatureFlagRulesMutation>;
export type UpdateFeatureFlagRulesMutationOptions = Apollo.BaseMutationOptions<UpdateFeatureFlagRulesMutation, UpdateFeatureFlagRulesMutationVariables>;
export const CreateFeatureFlagDocument = gql`
    mutation CreateFeatureFlag($name: String!, $description: String, $enabled: Boolean!, $rules: jsonb, $category: String, $createdBy: uuid) {
  insert_mix_feature_flag_one(
    object: {name: $name, description: $description, enabled: $enabled, rules: $rules, category: $category, created_by: $createdBy}
  ) {
    id
    name
    enabled
    rules
    category
  }
}
    `;
export type CreateFeatureFlagMutationFn = Apollo.MutationFunction<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables>;
export type CreateFeatureFlagComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables>, 'mutation'>;

    export const CreateFeatureFlagComponent = (props: CreateFeatureFlagComponentProps) => (
      <ApolloReactComponents.Mutation<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables> mutation={CreateFeatureFlagDocument} {...props} />
    );
    

/**
 * __useCreateFeatureFlagMutation__
 *
 * To run a mutation, you first call `useCreateFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFeatureFlagMutation, { data, loading, error }] = useCreateFeatureFlagMutation({
 *   variables: {
 *      name: // value for 'name'
 *      description: // value for 'description'
 *      enabled: // value for 'enabled'
 *      rules: // value for 'rules'
 *      category: // value for 'category'
 *      createdBy: // value for 'createdBy'
 *   },
 * });
 */
export function useCreateFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables>(CreateFeatureFlagDocument, options);
      }
export type CreateFeatureFlagMutationHookResult = ReturnType<typeof useCreateFeatureFlagMutation>;
export type CreateFeatureFlagMutationResult = Apollo.MutationResult<CreateFeatureFlagMutation>;
export type CreateFeatureFlagMutationOptions = Apollo.BaseMutationOptions<CreateFeatureFlagMutation, CreateFeatureFlagMutationVariables>;
export const DeleteFeatureFlagDocument = gql`
    mutation DeleteFeatureFlag($id: uuid!) {
  delete_mix_feature_flag_by_pk(id: $id) {
    id
    name
  }
}
    `;
export type DeleteFeatureFlagMutationFn = Apollo.MutationFunction<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>;
export type DeleteFeatureFlagComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>, 'mutation'>;

    export const DeleteFeatureFlagComponent = (props: DeleteFeatureFlagComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables> mutation={DeleteFeatureFlagDocument} {...props} />
    );
    

/**
 * __useDeleteFeatureFlagMutation__
 *
 * To run a mutation, you first call `useDeleteFeatureFlagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeatureFlagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeatureFlagMutation, { data, loading, error }] = useDeleteFeatureFlagMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeatureFlagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>(DeleteFeatureFlagDocument, options);
      }
export type DeleteFeatureFlagMutationHookResult = ReturnType<typeof useDeleteFeatureFlagMutation>;
export type DeleteFeatureFlagMutationResult = Apollo.MutationResult<DeleteFeatureFlagMutation>;
export type DeleteFeatureFlagMutationOptions = Apollo.BaseMutationOptions<DeleteFeatureFlagMutation, DeleteFeatureFlagMutationVariables>;
export const GetFeatureFlagAuditLogDocument = gql`
    query GetFeatureFlagAuditLog($flagId: uuid, $limit: Int = 50) {
  mix_feature_flag_audit(
    where: {flag_id: {_eq: $flagId}}
    order_by: {created_at: desc}
    limit: $limit
  ) {
    id
    flag_name
    old_enabled
    new_enabled
    old_rules
    new_rules
    change_reason
    created_at
    mix_user {
      id
      name
      profileImg
    }
  }
}
    `;
export type GetFeatureFlagAuditLogComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables>, 'query'>;

    export const GetFeatureFlagAuditLogComponent = (props: GetFeatureFlagAuditLogComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables> query={GetFeatureFlagAuditLogDocument} {...props} />
    );
    

/**
 * __useGetFeatureFlagAuditLogQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagAuditLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagAuditLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagAuditLogQuery({
 *   variables: {
 *      flagId: // value for 'flagId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetFeatureFlagAuditLogQuery(baseOptions?: Apollo.QueryHookOptions<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables>(GetFeatureFlagAuditLogDocument, options);
      }
export function useGetFeatureFlagAuditLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables>(GetFeatureFlagAuditLogDocument, options);
        }
export type GetFeatureFlagAuditLogQueryHookResult = ReturnType<typeof useGetFeatureFlagAuditLogQuery>;
export type GetFeatureFlagAuditLogLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagAuditLogLazyQuery>;
export type GetFeatureFlagAuditLogQueryResult = Apollo.QueryResult<GetFeatureFlagAuditLogQuery, GetFeatureFlagAuditLogQueryVariables>;
export const SubscribeToFeatureFlagsDocument = gql`
    subscription SubscribeToFeatureFlags {
  mix_feature_flag_active {
    id
    name
    enabled
    rules
  }
}
    `;
export type SubscribeToFeatureFlagsComponentProps = Omit<ApolloReactComponents.SubscriptionComponentOptions<SubscribeToFeatureFlagsSubscription, SubscribeToFeatureFlagsSubscriptionVariables>, 'subscription'>;

    export const SubscribeToFeatureFlagsComponent = (props: SubscribeToFeatureFlagsComponentProps) => (
      <ApolloReactComponents.Subscription<SubscribeToFeatureFlagsSubscription, SubscribeToFeatureFlagsSubscriptionVariables> subscription={SubscribeToFeatureFlagsDocument} {...props} />
    );
    

/**
 * __useSubscribeToFeatureFlagsSubscription__
 *
 * To run a query within a React component, call `useSubscribeToFeatureFlagsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useSubscribeToFeatureFlagsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscribeToFeatureFlagsSubscription({
 *   variables: {
 *   },
 * });
 */
export function useSubscribeToFeatureFlagsSubscription(baseOptions?: Apollo.SubscriptionHookOptions<SubscribeToFeatureFlagsSubscription, SubscribeToFeatureFlagsSubscriptionVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<SubscribeToFeatureFlagsSubscription, SubscribeToFeatureFlagsSubscriptionVariables>(SubscribeToFeatureFlagsDocument, options);
      }
export type SubscribeToFeatureFlagsSubscriptionHookResult = ReturnType<typeof useSubscribeToFeatureFlagsSubscription>;
export type SubscribeToFeatureFlagsSubscriptionResult = Apollo.SubscriptionResult<SubscribeToFeatureFlagsSubscription>;
export const GetUserInterestTagsDocument = gql`
    query getUserInterestTags($userId: uuid!) {
  mix_user_interest_tag(
    where: {user_id: {_eq: $userId}}
    order_by: {priority: asc}
  ) {
    tag_value
    priority
  }
}
    `;
export type GetUserInterestTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables>, 'query'> & ({ variables: GetUserInterestTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetUserInterestTagsComponent = (props: GetUserInterestTagsComponentProps) => (
      <ApolloReactComponents.Query<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables> query={GetUserInterestTagsDocument} {...props} />
    );
    

/**
 * __useGetUserInterestTagsQuery__
 *
 * To run a query within a React component, call `useGetUserInterestTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInterestTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInterestTagsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserInterestTagsQuery(baseOptions: Apollo.QueryHookOptions<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables>(GetUserInterestTagsDocument, options);
      }
export function useGetUserInterestTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables>(GetUserInterestTagsDocument, options);
        }
export type GetUserInterestTagsQueryHookResult = ReturnType<typeof useGetUserInterestTagsQuery>;
export type GetUserInterestTagsLazyQueryHookResult = ReturnType<typeof useGetUserInterestTagsLazyQuery>;
export type GetUserInterestTagsQueryResult = Apollo.QueryResult<GetUserInterestTagsQuery, GetUserInterestTagsQueryVariables>;
export const HistoryDocument = gql`
    query history($userId: uuid!, $offset: Int, $limit: Int) {
  mix_content_history(
    where: {userid: {_eq: $userId}}
    offset: $offset
    limit: $limit
    order_by: {updatetime: desc}
  ) {
    id
    mix_content {
      ...mix_content
    }
  }
}
    ${Mix_ContentFragmentDoc}`;
export type HistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HistoryQuery, HistoryQueryVariables>, 'query'> & ({ variables: HistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const HistoryComponent = (props: HistoryComponentProps) => (
      <ApolloReactComponents.Query<HistoryQuery, HistoryQueryVariables> query={HistoryDocument} {...props} />
    );
    

/**
 * __useHistoryQuery__
 *
 * To run a query within a React component, call `useHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      offset: // value for 'offset'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useHistoryQuery(baseOptions: Apollo.QueryHookOptions<HistoryQuery, HistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HistoryQuery, HistoryQueryVariables>(HistoryDocument, options);
      }
export function useHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HistoryQuery, HistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HistoryQuery, HistoryQueryVariables>(HistoryDocument, options);
        }
export type HistoryQueryHookResult = ReturnType<typeof useHistoryQuery>;
export type HistoryLazyQueryHookResult = ReturnType<typeof useHistoryLazyQuery>;
export type HistoryQueryResult = Apollo.QueryResult<HistoryQuery, HistoryQueryVariables>;
export const InsertBookmarkDocument = gql`
    mutation insertBookmark($contentId: uuid!) {
  insert_mix_content_bookmark_one(object: {contentid: $contentId}) {
    id
    mix_content {
      id
      bookmarked
    }
  }
}
    `;
export type InsertBookmarkMutationFn = Apollo.MutationFunction<InsertBookmarkMutation, InsertBookmarkMutationVariables>;
export type InsertBookmarkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertBookmarkMutation, InsertBookmarkMutationVariables>, 'mutation'>;

    export const InsertBookmarkComponent = (props: InsertBookmarkComponentProps) => (
      <ApolloReactComponents.Mutation<InsertBookmarkMutation, InsertBookmarkMutationVariables> mutation={InsertBookmarkDocument} {...props} />
    );
    

/**
 * __useInsertBookmarkMutation__
 *
 * To run a mutation, you first call `useInsertBookmarkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertBookmarkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertBookmarkMutation, { data, loading, error }] = useInsertBookmarkMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useInsertBookmarkMutation(baseOptions?: Apollo.MutationHookOptions<InsertBookmarkMutation, InsertBookmarkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertBookmarkMutation, InsertBookmarkMutationVariables>(InsertBookmarkDocument, options);
      }
export type InsertBookmarkMutationHookResult = ReturnType<typeof useInsertBookmarkMutation>;
export type InsertBookmarkMutationResult = Apollo.MutationResult<InsertBookmarkMutation>;
export type InsertBookmarkMutationOptions = Apollo.BaseMutationOptions<InsertBookmarkMutation, InsertBookmarkMutationVariables>;
export const InsertMixContentViewDocument = gql`
    mutation insertMixContentView($object: mix_content_view_insert_input!) {
  insert_mix_content_view_one(object: $object) {
    id
    contentid
    userid
    source
    createtime
  }
}
    `;
export type InsertMixContentViewMutationFn = Apollo.MutationFunction<InsertMixContentViewMutation, InsertMixContentViewMutationVariables>;
export type InsertMixContentViewComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertMixContentViewMutation, InsertMixContentViewMutationVariables>, 'mutation'>;

    export const InsertMixContentViewComponent = (props: InsertMixContentViewComponentProps) => (
      <ApolloReactComponents.Mutation<InsertMixContentViewMutation, InsertMixContentViewMutationVariables> mutation={InsertMixContentViewDocument} {...props} />
    );
    

/**
 * __useInsertMixContentViewMutation__
 *
 * To run a mutation, you first call `useInsertMixContentViewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMixContentViewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMixContentViewMutation, { data, loading, error }] = useInsertMixContentViewMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertMixContentViewMutation(baseOptions?: Apollo.MutationHookOptions<InsertMixContentViewMutation, InsertMixContentViewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMixContentViewMutation, InsertMixContentViewMutationVariables>(InsertMixContentViewDocument, options);
      }
export type InsertMixContentViewMutationHookResult = ReturnType<typeof useInsertMixContentViewMutation>;
export type InsertMixContentViewMutationResult = Apollo.MutationResult<InsertMixContentViewMutation>;
export type InsertMixContentViewMutationOptions = Apollo.BaseMutationOptions<InsertMixContentViewMutation, InsertMixContentViewMutationVariables>;
export const InsertOrderOneDocument = gql`
    mutation insertOrderOne($object: order_insert_input!) {
  insert_order_one(object: $object) {
    id
    order_token
  }
}
    `;
export type InsertOrderOneMutationFn = Apollo.MutationFunction<InsertOrderOneMutation, InsertOrderOneMutationVariables>;
export type InsertOrderOneComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertOrderOneMutation, InsertOrderOneMutationVariables>, 'mutation'>;

    export const InsertOrderOneComponent = (props: InsertOrderOneComponentProps) => (
      <ApolloReactComponents.Mutation<InsertOrderOneMutation, InsertOrderOneMutationVariables> mutation={InsertOrderOneDocument} {...props} />
    );
    

/**
 * __useInsertOrderOneMutation__
 *
 * To run a mutation, you first call `useInsertOrderOneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertOrderOneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertOrderOneMutation, { data, loading, error }] = useInsertOrderOneMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertOrderOneMutation(baseOptions?: Apollo.MutationHookOptions<InsertOrderOneMutation, InsertOrderOneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertOrderOneMutation, InsertOrderOneMutationVariables>(InsertOrderOneDocument, options);
      }
export type InsertOrderOneMutationHookResult = ReturnType<typeof useInsertOrderOneMutation>;
export type InsertOrderOneMutationResult = Apollo.MutationResult<InsertOrderOneMutation>;
export type InsertOrderOneMutationOptions = Apollo.BaseMutationOptions<InsertOrderOneMutation, InsertOrderOneMutationVariables>;
export const InsertUserDocument = gql`
    mutation insertUser($user: mix_user_insert_input!) {
  insert_mix_user_one(object: $user) {
    ...mix_user
  }
}
    ${Mix_UserFragmentDoc}`;
export type InsertUserMutationFn = Apollo.MutationFunction<InsertUserMutation, InsertUserMutationVariables>;
export type InsertUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertUserMutation, InsertUserMutationVariables>, 'mutation'>;

    export const InsertUserComponent = (props: InsertUserComponentProps) => (
      <ApolloReactComponents.Mutation<InsertUserMutation, InsertUserMutationVariables> mutation={InsertUserDocument} {...props} />
    );
    

/**
 * __useInsertUserMutation__
 *
 * To run a mutation, you first call `useInsertUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertUserMutation, { data, loading, error }] = useInsertUserMutation({
 *   variables: {
 *      user: // value for 'user'
 *   },
 * });
 */
export function useInsertUserMutation(baseOptions?: Apollo.MutationHookOptions<InsertUserMutation, InsertUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertUserMutation, InsertUserMutationVariables>(InsertUserDocument, options);
      }
export type InsertUserMutationHookResult = ReturnType<typeof useInsertUserMutation>;
export type InsertUserMutationResult = Apollo.MutationResult<InsertUserMutation>;
export type InsertUserMutationOptions = Apollo.BaseMutationOptions<InsertUserMutation, InsertUserMutationVariables>;
export const InsertWeeklyContentDocument = gql`
    mutation insertWeeklyContent($object: mix_content_insert_input!) {
  insert_mix_content_one(object: $object) {
    id
    contentid
    title
    category
    updatetime
    originalurl
  }
}
    `;
export type InsertWeeklyContentMutationFn = Apollo.MutationFunction<InsertWeeklyContentMutation, InsertWeeklyContentMutationVariables>;
export type InsertWeeklyContentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertWeeklyContentMutation, InsertWeeklyContentMutationVariables>, 'mutation'>;

    export const InsertWeeklyContentComponent = (props: InsertWeeklyContentComponentProps) => (
      <ApolloReactComponents.Mutation<InsertWeeklyContentMutation, InsertWeeklyContentMutationVariables> mutation={InsertWeeklyContentDocument} {...props} />
    );
    

/**
 * __useInsertWeeklyContentMutation__
 *
 * To run a mutation, you first call `useInsertWeeklyContentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertWeeklyContentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertWeeklyContentMutation, { data, loading, error }] = useInsertWeeklyContentMutation({
 *   variables: {
 *      object: // value for 'object'
 *   },
 * });
 */
export function useInsertWeeklyContentMutation(baseOptions?: Apollo.MutationHookOptions<InsertWeeklyContentMutation, InsertWeeklyContentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertWeeklyContentMutation, InsertWeeklyContentMutationVariables>(InsertWeeklyContentDocument, options);
      }
export type InsertWeeklyContentMutationHookResult = ReturnType<typeof useInsertWeeklyContentMutation>;
export type InsertWeeklyContentMutationResult = Apollo.MutationResult<InsertWeeklyContentMutation>;
export type InsertWeeklyContentMutationOptions = Apollo.BaseMutationOptions<InsertWeeklyContentMutation, InsertWeeklyContentMutationVariables>;
export const MixArchiveDocument = gql`
    query mixArchive($limit: Int, $offset: Int, $orderBy: [mix_archive_order_by!]) {
  mix_archive(limit: $limit, offset: $offset, order_by: $orderBy) {
    id
    title
    source
    sourcename
    mix_archive_sourcename {
      imgurl
      source
      sourcename
    }
    view_url
    download_url
    thumbnail_url
    tags
    created_at
    updated_at
    is_main_exposed
  }
}
    `;
export type MixArchiveComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixArchiveQuery, MixArchiveQueryVariables>, 'query'>;

    export const MixArchiveComponent = (props: MixArchiveComponentProps) => (
      <ApolloReactComponents.Query<MixArchiveQuery, MixArchiveQueryVariables> query={MixArchiveDocument} {...props} />
    );
    

/**
 * __useMixArchiveQuery__
 *
 * To run a query within a React component, call `useMixArchiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixArchiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixArchiveQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMixArchiveQuery(baseOptions?: Apollo.QueryHookOptions<MixArchiveQuery, MixArchiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixArchiveQuery, MixArchiveQueryVariables>(MixArchiveDocument, options);
      }
export function useMixArchiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixArchiveQuery, MixArchiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixArchiveQuery, MixArchiveQueryVariables>(MixArchiveDocument, options);
        }
export type MixArchiveQueryHookResult = ReturnType<typeof useMixArchiveQuery>;
export type MixArchiveLazyQueryHookResult = ReturnType<typeof useMixArchiveLazyQuery>;
export type MixArchiveQueryResult = Apollo.QueryResult<MixArchiveQuery, MixArchiveQueryVariables>;
export const MixArchiveMainExposedDocument = gql`
    query mixArchiveMainExposed($limit: Int, $orderBy: [mix_archive_order_by!]) {
  mix_archive(
    where: {is_main_exposed: {_eq: true}}
    limit: $limit
    order_by: $orderBy
  ) {
    id
    title
    source
    sourcename
    mix_archive_sourcename {
      imgurl
      source
      sourcename
    }
    view_url
    download_url
    thumbnail_url
    tags
    created_at
    updated_at
    is_main_exposed
  }
}
    `;
export type MixArchiveMainExposedComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables>, 'query'>;

    export const MixArchiveMainExposedComponent = (props: MixArchiveMainExposedComponentProps) => (
      <ApolloReactComponents.Query<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables> query={MixArchiveMainExposedDocument} {...props} />
    );
    

/**
 * __useMixArchiveMainExposedQuery__
 *
 * To run a query within a React component, call `useMixArchiveMainExposedQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixArchiveMainExposedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixArchiveMainExposedQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMixArchiveMainExposedQuery(baseOptions?: Apollo.QueryHookOptions<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables>(MixArchiveMainExposedDocument, options);
      }
export function useMixArchiveMainExposedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables>(MixArchiveMainExposedDocument, options);
        }
export type MixArchiveMainExposedQueryHookResult = ReturnType<typeof useMixArchiveMainExposedQuery>;
export type MixArchiveMainExposedLazyQueryHookResult = ReturnType<typeof useMixArchiveMainExposedLazyQuery>;
export type MixArchiveMainExposedQueryResult = Apollo.QueryResult<MixArchiveMainExposedQuery, MixArchiveMainExposedQueryVariables>;
export const MixArchiveTagsDocument = gql`
    query mixArchiveTags {
  mix_archive_tags {
    value
    comment
  }
}
    `;
export type MixArchiveTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixArchiveTagsQuery, MixArchiveTagsQueryVariables>, 'query'>;

    export const MixArchiveTagsComponent = (props: MixArchiveTagsComponentProps) => (
      <ApolloReactComponents.Query<MixArchiveTagsQuery, MixArchiveTagsQueryVariables> query={MixArchiveTagsDocument} {...props} />
    );
    

/**
 * __useMixArchiveTagsQuery__
 *
 * To run a query within a React component, call `useMixArchiveTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixArchiveTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixArchiveTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMixArchiveTagsQuery(baseOptions?: Apollo.QueryHookOptions<MixArchiveTagsQuery, MixArchiveTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixArchiveTagsQuery, MixArchiveTagsQueryVariables>(MixArchiveTagsDocument, options);
      }
export function useMixArchiveTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixArchiveTagsQuery, MixArchiveTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixArchiveTagsQuery, MixArchiveTagsQueryVariables>(MixArchiveTagsDocument, options);
        }
export type MixArchiveTagsQueryHookResult = ReturnType<typeof useMixArchiveTagsQuery>;
export type MixArchiveTagsLazyQueryHookResult = ReturnType<typeof useMixArchiveTagsLazyQuery>;
export type MixArchiveTagsQueryResult = Apollo.QueryResult<MixArchiveTagsQuery, MixArchiveTagsQueryVariables>;
export const MixArchiveBookmarkedIdsDocument = gql`
    query mixArchiveBookmarkedIds($userId: uuid!) {
  mix_archive_bookmark(where: {userid: {_eq: $userId}}) {
    archiveid
  }
}
    `;
export type MixArchiveBookmarkedIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables>, 'query'> & ({ variables: MixArchiveBookmarkedIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MixArchiveBookmarkedIdsComponent = (props: MixArchiveBookmarkedIdsComponentProps) => (
      <ApolloReactComponents.Query<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables> query={MixArchiveBookmarkedIdsDocument} {...props} />
    );
    

/**
 * __useMixArchiveBookmarkedIdsQuery__
 *
 * To run a query within a React component, call `useMixArchiveBookmarkedIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixArchiveBookmarkedIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixArchiveBookmarkedIdsQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useMixArchiveBookmarkedIdsQuery(baseOptions: Apollo.QueryHookOptions<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables>(MixArchiveBookmarkedIdsDocument, options);
      }
export function useMixArchiveBookmarkedIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables>(MixArchiveBookmarkedIdsDocument, options);
        }
export type MixArchiveBookmarkedIdsQueryHookResult = ReturnType<typeof useMixArchiveBookmarkedIdsQuery>;
export type MixArchiveBookmarkedIdsLazyQueryHookResult = ReturnType<typeof useMixArchiveBookmarkedIdsLazyQuery>;
export type MixArchiveBookmarkedIdsQueryResult = Apollo.QueryResult<MixArchiveBookmarkedIdsQuery, MixArchiveBookmarkedIdsQueryVariables>;
export const MixArchiveByPkDocument = gql`
    query mixArchiveByPk($id: uuid!) {
  mix_archive_by_pk(id: $id) {
    id
    title
    source
    sourcename
    mix_archive_sourcename {
      imgurl
      source
      sourcename
    }
    view_url
    download_url
    thumbnail_url
    tags
    created_at
    updated_at
    is_main_exposed
  }
}
    `;
export type MixArchiveByPkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixArchiveByPkQuery, MixArchiveByPkQueryVariables>, 'query'> & ({ variables: MixArchiveByPkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MixArchiveByPkComponent = (props: MixArchiveByPkComponentProps) => (
      <ApolloReactComponents.Query<MixArchiveByPkQuery, MixArchiveByPkQueryVariables> query={MixArchiveByPkDocument} {...props} />
    );
    

/**
 * __useMixArchiveByPkQuery__
 *
 * To run a query within a React component, call `useMixArchiveByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixArchiveByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixArchiveByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMixArchiveByPkQuery(baseOptions: Apollo.QueryHookOptions<MixArchiveByPkQuery, MixArchiveByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixArchiveByPkQuery, MixArchiveByPkQueryVariables>(MixArchiveByPkDocument, options);
      }
export function useMixArchiveByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixArchiveByPkQuery, MixArchiveByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixArchiveByPkQuery, MixArchiveByPkQueryVariables>(MixArchiveByPkDocument, options);
        }
export type MixArchiveByPkQueryHookResult = ReturnType<typeof useMixArchiveByPkQuery>;
export type MixArchiveByPkLazyQueryHookResult = ReturnType<typeof useMixArchiveByPkLazyQuery>;
export type MixArchiveByPkQueryResult = Apollo.QueryResult<MixArchiveByPkQuery, MixArchiveByPkQueryVariables>;
export const InsertMixArchiveDocument = gql`
    mutation insertMixArchive($objects: [mix_archive_insert_input!]!) {
  insert_mix_archive(objects: $objects) {
    affected_rows
    returning {
      id
      title
      source
      sourcename
      mix_archive_sourcename {
        imgurl
        source
        sourcename
      }
      view_url
      download_url
      thumbnail_url
      tags
      created_at
      updated_at
      is_main_exposed
    }
  }
}
    `;
export type InsertMixArchiveMutationFn = Apollo.MutationFunction<InsertMixArchiveMutation, InsertMixArchiveMutationVariables>;
export type InsertMixArchiveComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InsertMixArchiveMutation, InsertMixArchiveMutationVariables>, 'mutation'>;

    export const InsertMixArchiveComponent = (props: InsertMixArchiveComponentProps) => (
      <ApolloReactComponents.Mutation<InsertMixArchiveMutation, InsertMixArchiveMutationVariables> mutation={InsertMixArchiveDocument} {...props} />
    );
    

/**
 * __useInsertMixArchiveMutation__
 *
 * To run a mutation, you first call `useInsertMixArchiveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsertMixArchiveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insertMixArchiveMutation, { data, loading, error }] = useInsertMixArchiveMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useInsertMixArchiveMutation(baseOptions?: Apollo.MutationHookOptions<InsertMixArchiveMutation, InsertMixArchiveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsertMixArchiveMutation, InsertMixArchiveMutationVariables>(InsertMixArchiveDocument, options);
      }
export type InsertMixArchiveMutationHookResult = ReturnType<typeof useInsertMixArchiveMutation>;
export type InsertMixArchiveMutationResult = Apollo.MutationResult<InsertMixArchiveMutation>;
export type InsertMixArchiveMutationOptions = Apollo.BaseMutationOptions<InsertMixArchiveMutation, InsertMixArchiveMutationVariables>;
export const UpdateMixArchiveByPkDocument = gql`
    mutation updateMixArchiveByPk($id: uuid!, $set: mix_archive_set_input!) {
  update_mix_archive_by_pk(pk_columns: {id: $id}, _set: $set) {
    id
    title
    source
    sourcename
    mix_archive_sourcename {
      imgurl
      source
      sourcename
    }
    view_url
    download_url
    thumbnail_url
    tags
    created_at
    updated_at
    is_main_exposed
  }
}
    `;
export type UpdateMixArchiveByPkMutationFn = Apollo.MutationFunction<UpdateMixArchiveByPkMutation, UpdateMixArchiveByPkMutationVariables>;
export type UpdateMixArchiveByPkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMixArchiveByPkMutation, UpdateMixArchiveByPkMutationVariables>, 'mutation'>;

    export const UpdateMixArchiveByPkComponent = (props: UpdateMixArchiveByPkComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMixArchiveByPkMutation, UpdateMixArchiveByPkMutationVariables> mutation={UpdateMixArchiveByPkDocument} {...props} />
    );
    

/**
 * __useUpdateMixArchiveByPkMutation__
 *
 * To run a mutation, you first call `useUpdateMixArchiveByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMixArchiveByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMixArchiveByPkMutation, { data, loading, error }] = useUpdateMixArchiveByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *      set: // value for 'set'
 *   },
 * });
 */
export function useUpdateMixArchiveByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMixArchiveByPkMutation, UpdateMixArchiveByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMixArchiveByPkMutation, UpdateMixArchiveByPkMutationVariables>(UpdateMixArchiveByPkDocument, options);
      }
export type UpdateMixArchiveByPkMutationHookResult = ReturnType<typeof useUpdateMixArchiveByPkMutation>;
export type UpdateMixArchiveByPkMutationResult = Apollo.MutationResult<UpdateMixArchiveByPkMutation>;
export type UpdateMixArchiveByPkMutationOptions = Apollo.BaseMutationOptions<UpdateMixArchiveByPkMutation, UpdateMixArchiveByPkMutationVariables>;
export const DeleteMixArchiveByPkDocument = gql`
    mutation deleteMixArchiveByPk($id: uuid!) {
  delete_mix_archive_by_pk(id: $id) {
    id
  }
}
    `;
export type DeleteMixArchiveByPkMutationFn = Apollo.MutationFunction<DeleteMixArchiveByPkMutation, DeleteMixArchiveByPkMutationVariables>;
export type DeleteMixArchiveByPkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteMixArchiveByPkMutation, DeleteMixArchiveByPkMutationVariables>, 'mutation'>;

    export const DeleteMixArchiveByPkComponent = (props: DeleteMixArchiveByPkComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteMixArchiveByPkMutation, DeleteMixArchiveByPkMutationVariables> mutation={DeleteMixArchiveByPkDocument} {...props} />
    );
    

/**
 * __useDeleteMixArchiveByPkMutation__
 *
 * To run a mutation, you first call `useDeleteMixArchiveByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMixArchiveByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMixArchiveByPkMutation, { data, loading, error }] = useDeleteMixArchiveByPkMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMixArchiveByPkMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMixArchiveByPkMutation, DeleteMixArchiveByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMixArchiveByPkMutation, DeleteMixArchiveByPkMutationVariables>(DeleteMixArchiveByPkDocument, options);
      }
export type DeleteMixArchiveByPkMutationHookResult = ReturnType<typeof useDeleteMixArchiveByPkMutation>;
export type DeleteMixArchiveByPkMutationResult = Apollo.MutationResult<DeleteMixArchiveByPkMutation>;
export type DeleteMixArchiveByPkMutationOptions = Apollo.BaseMutationOptions<DeleteMixArchiveByPkMutation, DeleteMixArchiveByPkMutationVariables>;
export const MixClassCourseDocument = gql`
    query mixClassCourse($where: mix_class_course_bool_exp) {
  mix_class_course(where: $where, order_by: {created_at: desc}) {
    ...mixClassCourse
  }
}
    ${MixClassCourseFragmentDoc}`;
export type MixClassCourseComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixClassCourseQuery, MixClassCourseQueryVariables>, 'query'>;

    export const MixClassCourseComponent = (props: MixClassCourseComponentProps) => (
      <ApolloReactComponents.Query<MixClassCourseQuery, MixClassCourseQueryVariables> query={MixClassCourseDocument} {...props} />
    );
    

/**
 * __useMixClassCourseQuery__
 *
 * To run a query within a React component, call `useMixClassCourseQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixClassCourseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixClassCourseQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMixClassCourseQuery(baseOptions?: Apollo.QueryHookOptions<MixClassCourseQuery, MixClassCourseQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixClassCourseQuery, MixClassCourseQueryVariables>(MixClassCourseDocument, options);
      }
export function useMixClassCourseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixClassCourseQuery, MixClassCourseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixClassCourseQuery, MixClassCourseQueryVariables>(MixClassCourseDocument, options);
        }
export type MixClassCourseQueryHookResult = ReturnType<typeof useMixClassCourseQuery>;
export type MixClassCourseLazyQueryHookResult = ReturnType<typeof useMixClassCourseLazyQuery>;
export type MixClassCourseQueryResult = Apollo.QueryResult<MixClassCourseQuery, MixClassCourseQueryVariables>;
export const MixClassCourseByIdDocument = gql`
    query mixClassCourseById($id: Int!) {
  mix_class_course(where: {id: {_eq: $id}}) {
    ...mixClassCourse
    lectures_list: mix_class_lectures(order_by: {lecture_order: asc}) {
      ...mix_class_lecture
    }
  }
}
    ${MixClassCourseFragmentDoc}
${Mix_Class_LectureFragmentDoc}`;
export type MixClassCourseByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables>, 'query'> & ({ variables: MixClassCourseByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MixClassCourseByIdComponent = (props: MixClassCourseByIdComponentProps) => (
      <ApolloReactComponents.Query<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables> query={MixClassCourseByIdDocument} {...props} />
    );
    

/**
 * __useMixClassCourseByIdQuery__
 *
 * To run a query within a React component, call `useMixClassCourseByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixClassCourseByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixClassCourseByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMixClassCourseByIdQuery(baseOptions: Apollo.QueryHookOptions<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables>(MixClassCourseByIdDocument, options);
      }
export function useMixClassCourseByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables>(MixClassCourseByIdDocument, options);
        }
export type MixClassCourseByIdQueryHookResult = ReturnType<typeof useMixClassCourseByIdQuery>;
export type MixClassCourseByIdLazyQueryHookResult = ReturnType<typeof useMixClassCourseByIdLazyQuery>;
export type MixClassCourseByIdQueryResult = Apollo.QueryResult<MixClassCourseByIdQuery, MixClassCourseByIdQueryVariables>;
export const MixContentDocument = gql`
    query mixContent($where: mix_content_bool_exp, $limit: Int, $offset: Int, $orderBy: [mix_content_order_by!]) {
  mix_content(where: $where, limit: $limit, offset: $offset, order_by: $orderBy) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type MixContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixContentQuery, MixContentQueryVariables>, 'query'>;

    export const MixContentComponent = (props: MixContentComponentProps) => (
      <ApolloReactComponents.Query<MixContentQuery, MixContentQueryVariables> query={MixContentDocument} {...props} />
    );
    

/**
 * __useMixContentQuery__
 *
 * To run a query within a React component, call `useMixContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixContentQuery({
 *   variables: {
 *      where: // value for 'where'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useMixContentQuery(baseOptions?: Apollo.QueryHookOptions<MixContentQuery, MixContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixContentQuery, MixContentQueryVariables>(MixContentDocument, options);
      }
export function useMixContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixContentQuery, MixContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixContentQuery, MixContentQueryVariables>(MixContentDocument, options);
        }
export type MixContentQueryHookResult = ReturnType<typeof useMixContentQuery>;
export type MixContentLazyQueryHookResult = ReturnType<typeof useMixContentLazyQuery>;
export type MixContentQueryResult = Apollo.QueryResult<MixContentQuery, MixContentQueryVariables>;
export const MixContentByPkDocument = gql`
    query mixContentByPk($id: uuid!) {
  mix_content_by_pk(id: $id) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type MixContentByPkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixContentByPkQuery, MixContentByPkQueryVariables>, 'query'> & ({ variables: MixContentByPkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MixContentByPkComponent = (props: MixContentByPkComponentProps) => (
      <ApolloReactComponents.Query<MixContentByPkQuery, MixContentByPkQueryVariables> query={MixContentByPkDocument} {...props} />
    );
    

/**
 * __useMixContentByPkQuery__
 *
 * To run a query within a React component, call `useMixContentByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixContentByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixContentByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMixContentByPkQuery(baseOptions: Apollo.QueryHookOptions<MixContentByPkQuery, MixContentByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixContentByPkQuery, MixContentByPkQueryVariables>(MixContentByPkDocument, options);
      }
export function useMixContentByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixContentByPkQuery, MixContentByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixContentByPkQuery, MixContentByPkQueryVariables>(MixContentByPkDocument, options);
        }
export type MixContentByPkQueryHookResult = ReturnType<typeof useMixContentByPkQuery>;
export type MixContentByPkLazyQueryHookResult = ReturnType<typeof useMixContentByPkLazyQuery>;
export type MixContentByPkQueryResult = Apollo.QueryResult<MixContentByPkQuery, MixContentByPkQueryVariables>;
export const MixContentTagsDocument = gql`
    query mixContentTags {
  mix_content_tag_enum {
    value
    comment
  }
}
    `;
export type MixContentTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixContentTagsQuery, MixContentTagsQueryVariables>, 'query'>;

    export const MixContentTagsComponent = (props: MixContentTagsComponentProps) => (
      <ApolloReactComponents.Query<MixContentTagsQuery, MixContentTagsQueryVariables> query={MixContentTagsDocument} {...props} />
    );
    

/**
 * __useMixContentTagsQuery__
 *
 * To run a query within a React component, call `useMixContentTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixContentTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixContentTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMixContentTagsQuery(baseOptions?: Apollo.QueryHookOptions<MixContentTagsQuery, MixContentTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixContentTagsQuery, MixContentTagsQueryVariables>(MixContentTagsDocument, options);
      }
export function useMixContentTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixContentTagsQuery, MixContentTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixContentTagsQuery, MixContentTagsQueryVariables>(MixContentTagsDocument, options);
        }
export type MixContentTagsQueryHookResult = ReturnType<typeof useMixContentTagsQuery>;
export type MixContentTagsLazyQueryHookResult = ReturnType<typeof useMixContentTagsLazyQuery>;
export type MixContentTagsQueryResult = Apollo.QueryResult<MixContentTagsQuery, MixContentTagsQueryVariables>;
export const PopularContentsLast24HoursDocument = gql`
    query PopularContentsLast24Hours($limit: Int = 10) {
  mix_content_popular_last_24h_view(limit: $limit, order_by: {view_count: desc}) {
    contentid
    view_count
    content {
      title
      source
    }
  }
}
    `;
export type PopularContentsLast24HoursComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables>, 'query'>;

    export const PopularContentsLast24HoursComponent = (props: PopularContentsLast24HoursComponentProps) => (
      <ApolloReactComponents.Query<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables> query={PopularContentsLast24HoursDocument} {...props} />
    );
    

/**
 * __usePopularContentsLast24HoursQuery__
 *
 * To run a query within a React component, call `usePopularContentsLast24HoursQuery` and pass it any options that fit your needs.
 * When your component renders, `usePopularContentsLast24HoursQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePopularContentsLast24HoursQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function usePopularContentsLast24HoursQuery(baseOptions?: Apollo.QueryHookOptions<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables>(PopularContentsLast24HoursDocument, options);
      }
export function usePopularContentsLast24HoursLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables>(PopularContentsLast24HoursDocument, options);
        }
export type PopularContentsLast24HoursQueryHookResult = ReturnType<typeof usePopularContentsLast24HoursQuery>;
export type PopularContentsLast24HoursLazyQueryHookResult = ReturnType<typeof usePopularContentsLast24HoursLazyQuery>;
export type PopularContentsLast24HoursQueryResult = Apollo.QueryResult<PopularContentsLast24HoursQuery, PopularContentsLast24HoursQueryVariables>;
export const MixNoticesDocument = gql`
    query mixNotices {
  mix_notices(where: {is_active: {_eq: true}}, order_by: {id: desc}, limit: 1) {
    id
    type
    content
    start_at
    end_at
    target_url
    is_active
  }
}
    `;
export type MixNoticesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixNoticesQuery, MixNoticesQueryVariables>, 'query'>;

    export const MixNoticesComponent = (props: MixNoticesComponentProps) => (
      <ApolloReactComponents.Query<MixNoticesQuery, MixNoticesQueryVariables> query={MixNoticesDocument} {...props} />
    );
    

/**
 * __useMixNoticesQuery__
 *
 * To run a query within a React component, call `useMixNoticesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixNoticesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixNoticesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMixNoticesQuery(baseOptions?: Apollo.QueryHookOptions<MixNoticesQuery, MixNoticesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixNoticesQuery, MixNoticesQueryVariables>(MixNoticesDocument, options);
      }
export function useMixNoticesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixNoticesQuery, MixNoticesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixNoticesQuery, MixNoticesQueryVariables>(MixNoticesDocument, options);
        }
export type MixNoticesQueryHookResult = ReturnType<typeof useMixNoticesQuery>;
export type MixNoticesLazyQueryHookResult = ReturnType<typeof useMixNoticesLazyQuery>;
export type MixNoticesQueryResult = Apollo.QueryResult<MixNoticesQuery, MixNoticesQueryVariables>;
export const MixOriginalContentsDocument = gql`
    query mixOriginalContents {
  mix_content(where: {source: {_eq: "original"}}) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type MixOriginalContentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixOriginalContentsQuery, MixOriginalContentsQueryVariables>, 'query'>;

    export const MixOriginalContentsComponent = (props: MixOriginalContentsComponentProps) => (
      <ApolloReactComponents.Query<MixOriginalContentsQuery, MixOriginalContentsQueryVariables> query={MixOriginalContentsDocument} {...props} />
    );
    

/**
 * __useMixOriginalContentsQuery__
 *
 * To run a query within a React component, call `useMixOriginalContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixOriginalContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixOriginalContentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMixOriginalContentsQuery(baseOptions?: Apollo.QueryHookOptions<MixOriginalContentsQuery, MixOriginalContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixOriginalContentsQuery, MixOriginalContentsQueryVariables>(MixOriginalContentsDocument, options);
      }
export function useMixOriginalContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixOriginalContentsQuery, MixOriginalContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixOriginalContentsQuery, MixOriginalContentsQueryVariables>(MixOriginalContentsDocument, options);
        }
export type MixOriginalContentsQueryHookResult = ReturnType<typeof useMixOriginalContentsQuery>;
export type MixOriginalContentsLazyQueryHookResult = ReturnType<typeof useMixOriginalContentsLazyQuery>;
export type MixOriginalContentsQueryResult = Apollo.QueryResult<MixOriginalContentsQuery, MixOriginalContentsQueryVariables>;
export const MixSourceInfoDocument = gql`
    query mixSourceInfo {
  mix_source_info(where: {imgurl: {_is_null: false}}) {
    source
    imgurl
  }
}
    `;
export type MixSourceInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixSourceInfoQuery, MixSourceInfoQueryVariables>, 'query'>;

    export const MixSourceInfoComponent = (props: MixSourceInfoComponentProps) => (
      <ApolloReactComponents.Query<MixSourceInfoQuery, MixSourceInfoQueryVariables> query={MixSourceInfoDocument} {...props} />
    );
    

/**
 * __useMixSourceInfoQuery__
 *
 * To run a query within a React component, call `useMixSourceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixSourceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixSourceInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMixSourceInfoQuery(baseOptions?: Apollo.QueryHookOptions<MixSourceInfoQuery, MixSourceInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixSourceInfoQuery, MixSourceInfoQueryVariables>(MixSourceInfoDocument, options);
      }
export function useMixSourceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixSourceInfoQuery, MixSourceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixSourceInfoQuery, MixSourceInfoQueryVariables>(MixSourceInfoDocument, options);
        }
export type MixSourceInfoQueryHookResult = ReturnType<typeof useMixSourceInfoQuery>;
export type MixSourceInfoLazyQueryHookResult = ReturnType<typeof useMixSourceInfoLazyQuery>;
export type MixSourceInfoQueryResult = Apollo.QueryResult<MixSourceInfoQuery, MixSourceInfoQueryVariables>;
export const MixUserDocument = gql`
    query mixUser($where: mix_user_bool_exp) {
  mix_user(where: $where) {
    ...mix_user
  }
}
    ${Mix_UserFragmentDoc}`;
export type MixUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixUserQuery, MixUserQueryVariables>, 'query'>;

    export const MixUserComponent = (props: MixUserComponentProps) => (
      <ApolloReactComponents.Query<MixUserQuery, MixUserQueryVariables> query={MixUserDocument} {...props} />
    );
    

/**
 * __useMixUserQuery__
 *
 * To run a query within a React component, call `useMixUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixUserQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useMixUserQuery(baseOptions?: Apollo.QueryHookOptions<MixUserQuery, MixUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixUserQuery, MixUserQueryVariables>(MixUserDocument, options);
      }
export function useMixUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixUserQuery, MixUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixUserQuery, MixUserQueryVariables>(MixUserDocument, options);
        }
export type MixUserQueryHookResult = ReturnType<typeof useMixUserQuery>;
export type MixUserLazyQueryHookResult = ReturnType<typeof useMixUserLazyQuery>;
export type MixUserQueryResult = Apollo.QueryResult<MixUserQuery, MixUserQueryVariables>;
export const MixUserByPkDocument = gql`
    query mixUserByPk($id: uuid!) {
  mix_user_by_pk(id: $id) {
    ...mix_user
  }
}
    ${Mix_UserFragmentDoc}`;
export type MixUserByPkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixUserByPkQuery, MixUserByPkQueryVariables>, 'query'> & ({ variables: MixUserByPkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MixUserByPkComponent = (props: MixUserByPkComponentProps) => (
      <ApolloReactComponents.Query<MixUserByPkQuery, MixUserByPkQueryVariables> query={MixUserByPkDocument} {...props} />
    );
    

/**
 * __useMixUserByPkQuery__
 *
 * To run a query within a React component, call `useMixUserByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixUserByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixUserByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMixUserByPkQuery(baseOptions: Apollo.QueryHookOptions<MixUserByPkQuery, MixUserByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixUserByPkQuery, MixUserByPkQueryVariables>(MixUserByPkDocument, options);
      }
export function useMixUserByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixUserByPkQuery, MixUserByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixUserByPkQuery, MixUserByPkQueryVariables>(MixUserByPkDocument, options);
        }
export type MixUserByPkQueryHookResult = ReturnType<typeof useMixUserByPkQuery>;
export type MixUserByPkLazyQueryHookResult = ReturnType<typeof useMixUserByPkLazyQuery>;
export type MixUserByPkQueryResult = Apollo.QueryResult<MixUserByPkQuery, MixUserByPkQueryVariables>;
export const MixUserByRefreshTokenDocument = gql`
    query mixUserByRefreshToken($refreshToken: String!) {
  mix_user(where: {refreshToken: {_eq: $refreshToken}}) {
    id
    refreshTokenExpiry
  }
}
    `;
export type MixUserByRefreshTokenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables>, 'query'> & ({ variables: MixUserByRefreshTokenQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const MixUserByRefreshTokenComponent = (props: MixUserByRefreshTokenComponentProps) => (
      <ApolloReactComponents.Query<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables> query={MixUserByRefreshTokenDocument} {...props} />
    );
    

/**
 * __useMixUserByRefreshTokenQuery__
 *
 * To run a query within a React component, call `useMixUserByRefreshTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useMixUserByRefreshTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMixUserByRefreshTokenQuery({
 *   variables: {
 *      refreshToken: // value for 'refreshToken'
 *   },
 * });
 */
export function useMixUserByRefreshTokenQuery(baseOptions: Apollo.QueryHookOptions<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables>(MixUserByRefreshTokenDocument, options);
      }
export function useMixUserByRefreshTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables>(MixUserByRefreshTokenDocument, options);
        }
export type MixUserByRefreshTokenQueryHookResult = ReturnType<typeof useMixUserByRefreshTokenQuery>;
export type MixUserByRefreshTokenLazyQueryHookResult = ReturnType<typeof useMixUserByRefreshTokenLazyQuery>;
export type MixUserByRefreshTokenQueryResult = Apollo.QueryResult<MixUserByRefreshTokenQuery, MixUserByRefreshTokenQueryVariables>;
export const OrderDocument = gql`
    query order($where: order_bool_exp) {
  order(where: $where, order_by: {created_at: desc}) {
    ...order
  }
}
    ${OrderFragmentDoc}`;
export type OrderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderQuery, OrderQueryVariables>, 'query'>;

    export const OrderComponent = (props: OrderComponentProps) => (
      <ApolloReactComponents.Query<OrderQuery, OrderQueryVariables> query={OrderDocument} {...props} />
    );
    

/**
 * __useOrderQuery__
 *
 * To run a query within a React component, call `useOrderQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useOrderQuery(baseOptions?: Apollo.QueryHookOptions<OrderQuery, OrderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
      }
export function useOrderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderQuery, OrderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderQuery, OrderQueryVariables>(OrderDocument, options);
        }
export type OrderQueryHookResult = ReturnType<typeof useOrderQuery>;
export type OrderLazyQueryHookResult = ReturnType<typeof useOrderLazyQuery>;
export type OrderQueryResult = Apollo.QueryResult<OrderQuery, OrderQueryVariables>;
export const OrderByPkDocument = gql`
    query orderByPk($id: String!) {
  order_by_pk(id: $id) {
    ...order
  }
}
    ${OrderFragmentDoc}`;
export type OrderByPkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OrderByPkQuery, OrderByPkQueryVariables>, 'query'> & ({ variables: OrderByPkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OrderByPkComponent = (props: OrderByPkComponentProps) => (
      <ApolloReactComponents.Query<OrderByPkQuery, OrderByPkQueryVariables> query={OrderByPkDocument} {...props} />
    );
    

/**
 * __useOrderByPkQuery__
 *
 * To run a query within a React component, call `useOrderByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrderByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrderByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useOrderByPkQuery(baseOptions: Apollo.QueryHookOptions<OrderByPkQuery, OrderByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrderByPkQuery, OrderByPkQueryVariables>(OrderByPkDocument, options);
      }
export function useOrderByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrderByPkQuery, OrderByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrderByPkQuery, OrderByPkQueryVariables>(OrderByPkDocument, options);
        }
export type OrderByPkQueryHookResult = ReturnType<typeof useOrderByPkQuery>;
export type OrderByPkLazyQueryHookResult = ReturnType<typeof useOrderByPkLazyQuery>;
export type OrderByPkQueryResult = Apollo.QueryResult<OrderByPkQuery, OrderByPkQueryVariables>;
export const OriginalContentEncoreDocument = gql`
    query originalContentEncore($contentid: uuid!, $userid: uuid!) {
  mix_content_encore(
    where: {contentid: {_eq: $contentid}, userid: {_eq: $userid}}
  ) {
    id
    contentid
    userid
    count
  }
  mix_content_encore_aggregate(where: {contentid: {_eq: $contentid}}) {
    aggregate {
      sum {
        count
      }
    }
  }
}
    `;
export type OriginalContentEncoreComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables>, 'query'> & ({ variables: OriginalContentEncoreQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const OriginalContentEncoreComponent = (props: OriginalContentEncoreComponentProps) => (
      <ApolloReactComponents.Query<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables> query={OriginalContentEncoreDocument} {...props} />
    );
    

/**
 * __useOriginalContentEncoreQuery__
 *
 * To run a query within a React component, call `useOriginalContentEncoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useOriginalContentEncoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOriginalContentEncoreQuery({
 *   variables: {
 *      contentid: // value for 'contentid'
 *      userid: // value for 'userid'
 *   },
 * });
 */
export function useOriginalContentEncoreQuery(baseOptions: Apollo.QueryHookOptions<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables>(OriginalContentEncoreDocument, options);
      }
export function useOriginalContentEncoreLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables>(OriginalContentEncoreDocument, options);
        }
export type OriginalContentEncoreQueryHookResult = ReturnType<typeof useOriginalContentEncoreQuery>;
export type OriginalContentEncoreLazyQueryHookResult = ReturnType<typeof useOriginalContentEncoreLazyQuery>;
export type OriginalContentEncoreQueryResult = Apollo.QueryResult<OriginalContentEncoreQuery, OriginalContentEncoreQueryVariables>;
export const PersonalFeedContentDocument = gql`
    query PersonalFeedContent($tags: [String!], $tagLimit: Int = 10, $popularLimit: Int = 10) {
  tag_based_content: mix_content(
    where: {mix_content_tags: {mix_content_tag_enum: {value: {_in: $tags}}}, released: {_eq: true}}
    limit: $tagLimit
    order_by: {updatedate: desc}
  ) {
    ...mix_content
  }
  popular_content: mix_content_popular_last_24h_view(
    limit: $popularLimit
    order_by: {view_count: desc}
  ) {
    contentid
    view_count
    content {
      ...mix_content
    }
  }
}
    ${Mix_ContentFragmentDoc}`;
export type PersonalFeedContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PersonalFeedContentQuery, PersonalFeedContentQueryVariables>, 'query'>;

    export const PersonalFeedContentComponent = (props: PersonalFeedContentComponentProps) => (
      <ApolloReactComponents.Query<PersonalFeedContentQuery, PersonalFeedContentQueryVariables> query={PersonalFeedContentDocument} {...props} />
    );
    

/**
 * __usePersonalFeedContentQuery__
 *
 * To run a query within a React component, call `usePersonalFeedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePersonalFeedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePersonalFeedContentQuery({
 *   variables: {
 *      tags: // value for 'tags'
 *      tagLimit: // value for 'tagLimit'
 *      popularLimit: // value for 'popularLimit'
 *   },
 * });
 */
export function usePersonalFeedContentQuery(baseOptions?: Apollo.QueryHookOptions<PersonalFeedContentQuery, PersonalFeedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PersonalFeedContentQuery, PersonalFeedContentQueryVariables>(PersonalFeedContentDocument, options);
      }
export function usePersonalFeedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PersonalFeedContentQuery, PersonalFeedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PersonalFeedContentQuery, PersonalFeedContentQueryVariables>(PersonalFeedContentDocument, options);
        }
export type PersonalFeedContentQueryHookResult = ReturnType<typeof usePersonalFeedContentQuery>;
export type PersonalFeedContentLazyQueryHookResult = ReturnType<typeof usePersonalFeedContentLazyQuery>;
export type PersonalFeedContentQueryResult = Apollo.QueryResult<PersonalFeedContentQuery, PersonalFeedContentQueryVariables>;
export const PreviousWeekPopularContentsDocument = gql`
    query PreviousWeekPopularContents($startDate: timestamp!, $endDate: timestamp!, $excludeContentIds: [uuid!] = []) {
  views: mix_content_view(
    where: {createtime: {_gte: $startDate, _lte: $endDate}, contentid: {_nin: $excludeContentIds}}
  ) {
    contentid
  }
}
    `;
export type PreviousWeekPopularContentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables>, 'query'> & ({ variables: PreviousWeekPopularContentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const PreviousWeekPopularContentsComponent = (props: PreviousWeekPopularContentsComponentProps) => (
      <ApolloReactComponents.Query<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables> query={PreviousWeekPopularContentsDocument} {...props} />
    );
    

/**
 * __usePreviousWeekPopularContentsQuery__
 *
 * To run a query within a React component, call `usePreviousWeekPopularContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviousWeekPopularContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviousWeekPopularContentsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      excludeContentIds: // value for 'excludeContentIds'
 *   },
 * });
 */
export function usePreviousWeekPopularContentsQuery(baseOptions: Apollo.QueryHookOptions<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables>(PreviousWeekPopularContentsDocument, options);
      }
export function usePreviousWeekPopularContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables>(PreviousWeekPopularContentsDocument, options);
        }
export type PreviousWeekPopularContentsQueryHookResult = ReturnType<typeof usePreviousWeekPopularContentsQuery>;
export type PreviousWeekPopularContentsLazyQueryHookResult = ReturnType<typeof usePreviousWeekPopularContentsLazyQuery>;
export type PreviousWeekPopularContentsQueryResult = Apollo.QueryResult<PreviousWeekPopularContentsQuery, PreviousWeekPopularContentsQueryVariables>;
export const ContentDetailsByIdsDocument = gql`
    query ContentDetailsByIds($contentIds: [String!]!) {
  mix_content(where: {contentid: {_in: $contentIds}}) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type ContentDetailsByIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables>, 'query'> & ({ variables: ContentDetailsByIdsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ContentDetailsByIdsComponent = (props: ContentDetailsByIdsComponentProps) => (
      <ApolloReactComponents.Query<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables> query={ContentDetailsByIdsDocument} {...props} />
    );
    

/**
 * __useContentDetailsByIdsQuery__
 *
 * To run a query within a React component, call `useContentDetailsByIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentDetailsByIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentDetailsByIdsQuery({
 *   variables: {
 *      contentIds: // value for 'contentIds'
 *   },
 * });
 */
export function useContentDetailsByIdsQuery(baseOptions: Apollo.QueryHookOptions<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables>(ContentDetailsByIdsDocument, options);
      }
export function useContentDetailsByIdsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables>(ContentDetailsByIdsDocument, options);
        }
export type ContentDetailsByIdsQueryHookResult = ReturnType<typeof useContentDetailsByIdsQuery>;
export type ContentDetailsByIdsLazyQueryHookResult = ReturnType<typeof useContentDetailsByIdsLazyQuery>;
export type ContentDetailsByIdsQueryResult = Apollo.QueryResult<ContentDetailsByIdsQuery, ContentDetailsByIdsQueryVariables>;
export const PreviouslyFeaturedContentDocument = gql`
    query PreviouslyFeaturedContent {
  mix_content(
    where: {category: {_eq: Best_Contents}, source: {_eq: "original"}}
    order_by: {updatetime: desc}
    limit: 4
  ) {
    contentid
    updatetime
  }
}
    `;
export type PreviouslyFeaturedContentComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables>, 'query'>;

    export const PreviouslyFeaturedContentComponent = (props: PreviouslyFeaturedContentComponentProps) => (
      <ApolloReactComponents.Query<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables> query={PreviouslyFeaturedContentDocument} {...props} />
    );
    

/**
 * __usePreviouslyFeaturedContentQuery__
 *
 * To run a query within a React component, call `usePreviouslyFeaturedContentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePreviouslyFeaturedContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePreviouslyFeaturedContentQuery({
 *   variables: {
 *   },
 * });
 */
export function usePreviouslyFeaturedContentQuery(baseOptions?: Apollo.QueryHookOptions<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables>(PreviouslyFeaturedContentDocument, options);
      }
export function usePreviouslyFeaturedContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables>(PreviouslyFeaturedContentDocument, options);
        }
export type PreviouslyFeaturedContentQueryHookResult = ReturnType<typeof usePreviouslyFeaturedContentQuery>;
export type PreviouslyFeaturedContentLazyQueryHookResult = ReturnType<typeof usePreviouslyFeaturedContentLazyQuery>;
export type PreviouslyFeaturedContentQueryResult = Apollo.QueryResult<PreviouslyFeaturedContentQuery, PreviouslyFeaturedContentQueryVariables>;
export const ProductDocument = gql`
    query product($where: product_bool_exp) {
  product(where: $where, order_by: {created_at: desc}) {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export type ProductComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductQuery, ProductQueryVariables>, 'query'>;

    export const ProductComponent = (props: ProductComponentProps) => (
      <ApolloReactComponents.Query<ProductQuery, ProductQueryVariables> query={ProductDocument} {...props} />
    );
    

/**
 * __useProductQuery__
 *
 * To run a query within a React component, call `useProductQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function useProductQuery(baseOptions?: Apollo.QueryHookOptions<ProductQuery, ProductQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
      }
export function useProductLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductQuery, ProductQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductQuery, ProductQueryVariables>(ProductDocument, options);
        }
export type ProductQueryHookResult = ReturnType<typeof useProductQuery>;
export type ProductLazyQueryHookResult = ReturnType<typeof useProductLazyQuery>;
export type ProductQueryResult = Apollo.QueryResult<ProductQuery, ProductQueryVariables>;
export const ProductByPkDocument = gql`
    query productByPk($id: uuid!) {
  product_by_pk(id: $id) {
    ...product
  }
}
    ${ProductFragmentDoc}`;
export type ProductByPkComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProductByPkQuery, ProductByPkQueryVariables>, 'query'> & ({ variables: ProductByPkQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ProductByPkComponent = (props: ProductByPkComponentProps) => (
      <ApolloReactComponents.Query<ProductByPkQuery, ProductByPkQueryVariables> query={ProductByPkDocument} {...props} />
    );
    

/**
 * __useProductByPkQuery__
 *
 * To run a query within a React component, call `useProductByPkQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductByPkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductByPkQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useProductByPkQuery(baseOptions: Apollo.QueryHookOptions<ProductByPkQuery, ProductByPkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductByPkQuery, ProductByPkQueryVariables>(ProductByPkDocument, options);
      }
export function useProductByPkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductByPkQuery, ProductByPkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductByPkQuery, ProductByPkQueryVariables>(ProductByPkDocument, options);
        }
export type ProductByPkQueryHookResult = ReturnType<typeof useProductByPkQuery>;
export type ProductByPkLazyQueryHookResult = ReturnType<typeof useProductByPkLazyQuery>;
export type ProductByPkQueryResult = Apollo.QueryResult<ProductByPkQuery, ProductByPkQueryVariables>;
export const RecentWeeklyCompilationsDocument = gql`
    query RecentWeeklyCompilations($limit: Int = 1) {
  mix_content(
    where: {category: {_eq: Best_Contents}, source: {_eq: "original"}}
    order_by: {updatetime: desc}
    limit: $limit
  ) {
    contentid
    abstractcontents
    updatetime
  }
}
    `;
export type RecentWeeklyCompilationsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables>, 'query'>;

    export const RecentWeeklyCompilationsComponent = (props: RecentWeeklyCompilationsComponentProps) => (
      <ApolloReactComponents.Query<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables> query={RecentWeeklyCompilationsDocument} {...props} />
    );
    

/**
 * __useRecentWeeklyCompilationsQuery__
 *
 * To run a query within a React component, call `useRecentWeeklyCompilationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentWeeklyCompilationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentWeeklyCompilationsQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRecentWeeklyCompilationsQuery(baseOptions?: Apollo.QueryHookOptions<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables>(RecentWeeklyCompilationsDocument, options);
      }
export function useRecentWeeklyCompilationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables>(RecentWeeklyCompilationsDocument, options);
        }
export type RecentWeeklyCompilationsQueryHookResult = ReturnType<typeof useRecentWeeklyCompilationsQuery>;
export type RecentWeeklyCompilationsLazyQueryHookResult = ReturnType<typeof useRecentWeeklyCompilationsLazyQuery>;
export type RecentWeeklyCompilationsQueryResult = Apollo.QueryResult<RecentWeeklyCompilationsQuery, RecentWeeklyCompilationsQueryVariables>;
export const GetRelatedContentByTagsDocument = gql`
    query GetRelatedContentByTags($tags: [String!]!, $limit: Int = 6) {
  mix_content(
    where: {source: {_neq: "original"}, mix_content_tags: {mix_content_tag_enum: {value: {_in: $tags}}}}
    limit: $limit
    order_by: {updatetime: desc}
  ) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type GetRelatedContentByTagsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables>, 'query'> & ({ variables: GetRelatedContentByTagsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRelatedContentByTagsComponent = (props: GetRelatedContentByTagsComponentProps) => (
      <ApolloReactComponents.Query<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables> query={GetRelatedContentByTagsDocument} {...props} />
    );
    

/**
 * __useGetRelatedContentByTagsQuery__
 *
 * To run a query within a React component, call `useGetRelatedContentByTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelatedContentByTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelatedContentByTagsQuery({
 *   variables: {
 *      tags: // value for 'tags'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRelatedContentByTagsQuery(baseOptions: Apollo.QueryHookOptions<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables>(GetRelatedContentByTagsDocument, options);
      }
export function useGetRelatedContentByTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables>(GetRelatedContentByTagsDocument, options);
        }
export type GetRelatedContentByTagsQueryHookResult = ReturnType<typeof useGetRelatedContentByTagsQuery>;
export type GetRelatedContentByTagsLazyQueryHookResult = ReturnType<typeof useGetRelatedContentByTagsLazyQuery>;
export type GetRelatedContentByTagsQueryResult = Apollo.QueryResult<GetRelatedContentByTagsQuery, GetRelatedContentByTagsQueryVariables>;
export const SearchDocument = gql`
    query search($text: String!, $limit: Int, $offset: Int) {
  mix_content(
    where: {status: {_eq: published}, _or: [{authorname: {_ilike: $text}}, {title: {_ilike: $text}}, {abstractcontents: {_ilike: $text}}]}
    limit: $limit
    offset: $offset
    order_by: {updatetime: desc}
  ) {
    ...mix_content
  }
}
    ${Mix_ContentFragmentDoc}`;
export type SearchComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchQuery, SearchQueryVariables>, 'query'> & ({ variables: SearchQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchComponent = (props: SearchComponentProps) => (
      <ApolloReactComponents.Query<SearchQuery, SearchQueryVariables> query={SearchDocument} {...props} />
    );
    

/**
 * __useSearchQuery__
 *
 * To run a query within a React component, call `useSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchQuery({
 *   variables: {
 *      text: // value for 'text'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchQuery(baseOptions: Apollo.QueryHookOptions<SearchQuery, SearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
      }
export function useSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchQuery, SearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchQuery, SearchQueryVariables>(SearchDocument, options);
        }
export type SearchQueryHookResult = ReturnType<typeof useSearchQuery>;
export type SearchLazyQueryHookResult = ReturnType<typeof useSearchLazyQuery>;
export type SearchQueryResult = Apollo.QueryResult<SearchQuery, SearchQueryVariables>;
export const SearchArchiveDocument = gql`
    query searchArchive($text: String!, $limit: Int, $offset: Int) {
  mix_archive(
    where: {_or: [{title: {_ilike: $text}}, {source: {_ilike: $text}}, {sourcename: {_ilike: $text}}]}
    limit: $limit
    offset: $offset
    order_by: {created_at: desc}
  ) {
    id
    title
    source
    sourcename
    mix_archive_sourcename {
      imgurl
      source
      sourcename
    }
    view_url
    download_url
    thumbnail_url
    tags
    created_at
    updated_at
  }
}
    `;
export type SearchArchiveComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchArchiveQuery, SearchArchiveQueryVariables>, 'query'> & ({ variables: SearchArchiveQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SearchArchiveComponent = (props: SearchArchiveComponentProps) => (
      <ApolloReactComponents.Query<SearchArchiveQuery, SearchArchiveQueryVariables> query={SearchArchiveDocument} {...props} />
    );
    

/**
 * __useSearchArchiveQuery__
 *
 * To run a query within a React component, call `useSearchArchiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchArchiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchArchiveQuery({
 *   variables: {
 *      text: // value for 'text'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSearchArchiveQuery(baseOptions: Apollo.QueryHookOptions<SearchArchiveQuery, SearchArchiveQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchArchiveQuery, SearchArchiveQueryVariables>(SearchArchiveDocument, options);
      }
export function useSearchArchiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchArchiveQuery, SearchArchiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchArchiveQuery, SearchArchiveQueryVariables>(SearchArchiveDocument, options);
        }
export type SearchArchiveQueryHookResult = ReturnType<typeof useSearchArchiveQuery>;
export type SearchArchiveLazyQueryHookResult = ReturnType<typeof useSearchArchiveLazyQuery>;
export type SearchArchiveQueryResult = Apollo.QueryResult<SearchArchiveQuery, SearchArchiveQueryVariables>;
export const SessionDocument = gql`
    query session {
  session {
    id
    userId
    me {
      ...mix_user
    }
  }
}
    ${Mix_UserFragmentDoc}`;
export type SessionComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SessionQuery, SessionQueryVariables>, 'query'>;

    export const SessionComponent = (props: SessionComponentProps) => (
      <ApolloReactComponents.Query<SessionQuery, SessionQueryVariables> query={SessionDocument} {...props} />
    );
    

/**
 * __useSessionQuery__
 *
 * To run a query within a React component, call `useSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSessionQuery({
 *   variables: {
 *   },
 * });
 */
export function useSessionQuery(baseOptions?: Apollo.QueryHookOptions<SessionQuery, SessionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
      }
export function useSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SessionQuery, SessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SessionQuery, SessionQueryVariables>(SessionDocument, options);
        }
export type SessionQueryHookResult = ReturnType<typeof useSessionQuery>;
export type SessionLazyQueryHookResult = ReturnType<typeof useSessionLazyQuery>;
export type SessionQueryResult = Apollo.QueryResult<SessionQuery, SessionQueryVariables>;
export const TossPaymentsOrgCodeDocument = gql`
    query tossPaymentsOrgCode {
  toss_payments_org_code {
    id
    category
    organization
    code_num
    code_eng
    code_kor
    toss_update_date
  }
}
    `;
export type TossPaymentsOrgCodeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables>, 'query'>;

    export const TossPaymentsOrgCodeComponent = (props: TossPaymentsOrgCodeComponentProps) => (
      <ApolloReactComponents.Query<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables> query={TossPaymentsOrgCodeDocument} {...props} />
    );
    

/**
 * __useTossPaymentsOrgCodeQuery__
 *
 * To run a query within a React component, call `useTossPaymentsOrgCodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useTossPaymentsOrgCodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTossPaymentsOrgCodeQuery({
 *   variables: {
 *   },
 * });
 */
export function useTossPaymentsOrgCodeQuery(baseOptions?: Apollo.QueryHookOptions<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables>(TossPaymentsOrgCodeDocument, options);
      }
export function useTossPaymentsOrgCodeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables>(TossPaymentsOrgCodeDocument, options);
        }
export type TossPaymentsOrgCodeQueryHookResult = ReturnType<typeof useTossPaymentsOrgCodeQuery>;
export type TossPaymentsOrgCodeLazyQueryHookResult = ReturnType<typeof useTossPaymentsOrgCodeLazyQuery>;
export type TossPaymentsOrgCodeQueryResult = Apollo.QueryResult<TossPaymentsOrgCodeQuery, TossPaymentsOrgCodeQueryVariables>;
export const UpdateMeDocument = gql`
    mutation updateMe($_set: mix_user_set_input!, $id: uuid!) {
  update_mix_user_by_pk(_set: $_set, pk_columns: {id: $id}) {
    ...mix_user
  }
}
    ${Mix_UserFragmentDoc}`;
export type UpdateMeMutationFn = Apollo.MutationFunction<UpdateMeMutation, UpdateMeMutationVariables>;
export type UpdateMeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateMeMutation, UpdateMeMutationVariables>, 'mutation'>;

    export const UpdateMeComponent = (props: UpdateMeComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateMeMutation, UpdateMeMutationVariables> mutation={UpdateMeDocument} {...props} />
    );
    

/**
 * __useUpdateMeMutation__
 *
 * To run a mutation, you first call `useUpdateMeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMeMutation, { data, loading, error }] = useUpdateMeMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateMeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMeMutation, UpdateMeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMeMutation, UpdateMeMutationVariables>(UpdateMeDocument, options);
      }
export type UpdateMeMutationHookResult = ReturnType<typeof useUpdateMeMutation>;
export type UpdateMeMutationResult = Apollo.MutationResult<UpdateMeMutation>;
export type UpdateMeMutationOptions = Apollo.BaseMutationOptions<UpdateMeMutation, UpdateMeMutationVariables>;
export const UpdateOrderByPkDocument = gql`
    mutation updateOrderByPk($_set: order_set_input!, $id: String!) {
  update_order_by_pk(_set: $_set, pk_columns: {id: $id}) {
    ...order
  }
}
    ${OrderFragmentDoc}`;
export type UpdateOrderByPkMutationFn = Apollo.MutationFunction<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>;
export type UpdateOrderByPkComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>, 'mutation'>;

    export const UpdateOrderByPkComponent = (props: UpdateOrderByPkComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables> mutation={UpdateOrderByPkDocument} {...props} />
    );
    

/**
 * __useUpdateOrderByPkMutation__
 *
 * To run a mutation, you first call `useUpdateOrderByPkMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrderByPkMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrderByPkMutation, { data, loading, error }] = useUpdateOrderByPkMutation({
 *   variables: {
 *      _set: // value for '_set'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUpdateOrderByPkMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>(UpdateOrderByPkDocument, options);
      }
export type UpdateOrderByPkMutationHookResult = ReturnType<typeof useUpdateOrderByPkMutation>;
export type UpdateOrderByPkMutationResult = Apollo.MutationResult<UpdateOrderByPkMutation>;
export type UpdateOrderByPkMutationOptions = Apollo.BaseMutationOptions<UpdateOrderByPkMutation, UpdateOrderByPkMutationVariables>;
export const UpsertContentHistoryDocument = gql`
    mutation upsertContentHistory($contentId: uuid!) {
  insert_mix_content_history_one(
    object: {contentid: $contentId}
    on_conflict: {constraint: mix_content_history_userid_contentid_key, update_columns: [updatetime]}
  ) {
    id
  }
}
    `;
export type UpsertContentHistoryMutationFn = Apollo.MutationFunction<UpsertContentHistoryMutation, UpsertContentHistoryMutationVariables>;
export type UpsertContentHistoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertContentHistoryMutation, UpsertContentHistoryMutationVariables>, 'mutation'>;

    export const UpsertContentHistoryComponent = (props: UpsertContentHistoryComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertContentHistoryMutation, UpsertContentHistoryMutationVariables> mutation={UpsertContentHistoryDocument} {...props} />
    );
    

/**
 * __useUpsertContentHistoryMutation__
 *
 * To run a mutation, you first call `useUpsertContentHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertContentHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertContentHistoryMutation, { data, loading, error }] = useUpsertContentHistoryMutation({
 *   variables: {
 *      contentId: // value for 'contentId'
 *   },
 * });
 */
export function useUpsertContentHistoryMutation(baseOptions?: Apollo.MutationHookOptions<UpsertContentHistoryMutation, UpsertContentHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertContentHistoryMutation, UpsertContentHistoryMutationVariables>(UpsertContentHistoryDocument, options);
      }
export type UpsertContentHistoryMutationHookResult = ReturnType<typeof useUpsertContentHistoryMutation>;
export type UpsertContentHistoryMutationResult = Apollo.MutationResult<UpsertContentHistoryMutation>;
export type UpsertContentHistoryMutationOptions = Apollo.BaseMutationOptions<UpsertContentHistoryMutation, UpsertContentHistoryMutationVariables>;
export const UpsertMixContentEncoreDocument = gql`
    mutation upsertMixContentEncore($contentid: uuid!, $count: Int!) {
  insert_mix_content_encore_one(
    object: {contentid: $contentid, count: $count}
    on_conflict: {constraint: mix_content_encore_contentid_userid_key, update_columns: [count]}
  ) {
    id
    contentid
    userid
    count
  }
}
    `;
export type UpsertMixContentEncoreMutationFn = Apollo.MutationFunction<UpsertMixContentEncoreMutation, UpsertMixContentEncoreMutationVariables>;
export type UpsertMixContentEncoreComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertMixContentEncoreMutation, UpsertMixContentEncoreMutationVariables>, 'mutation'>;

    export const UpsertMixContentEncoreComponent = (props: UpsertMixContentEncoreComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertMixContentEncoreMutation, UpsertMixContentEncoreMutationVariables> mutation={UpsertMixContentEncoreDocument} {...props} />
    );
    

/**
 * __useUpsertMixContentEncoreMutation__
 *
 * To run a mutation, you first call `useUpsertMixContentEncoreMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMixContentEncoreMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMixContentEncoreMutation, { data, loading, error }] = useUpsertMixContentEncoreMutation({
 *   variables: {
 *      contentid: // value for 'contentid'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useUpsertMixContentEncoreMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMixContentEncoreMutation, UpsertMixContentEncoreMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMixContentEncoreMutation, UpsertMixContentEncoreMutationVariables>(UpsertMixContentEncoreDocument, options);
      }
export type UpsertMixContentEncoreMutationHookResult = ReturnType<typeof useUpsertMixContentEncoreMutation>;
export type UpsertMixContentEncoreMutationResult = Apollo.MutationResult<UpsertMixContentEncoreMutation>;
export type UpsertMixContentEncoreMutationOptions = Apollo.BaseMutationOptions<UpsertMixContentEncoreMutation, UpsertMixContentEncoreMutationVariables>;
export const UpsertOfflineAttendeeDocument = gql`
    mutation upsertOfflineAttendee($objects: [offline_attendee_insert_input!]!) {
  insert_offline_attendee(
    objects: $objects
    on_conflict: {constraint: offline_attendee_order_id_phone_key, update_columns: [email, name, company, position, career, advance_question, team_and_role, is_vip_networking_enrolled]}
  ) {
    returning {
      id
      order_id
    }
  }
}
    `;
export type UpsertOfflineAttendeeMutationFn = Apollo.MutationFunction<UpsertOfflineAttendeeMutation, UpsertOfflineAttendeeMutationVariables>;
export type UpsertOfflineAttendeeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertOfflineAttendeeMutation, UpsertOfflineAttendeeMutationVariables>, 'mutation'>;

    export const UpsertOfflineAttendeeComponent = (props: UpsertOfflineAttendeeComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertOfflineAttendeeMutation, UpsertOfflineAttendeeMutationVariables> mutation={UpsertOfflineAttendeeDocument} {...props} />
    );
    

/**
 * __useUpsertOfflineAttendeeMutation__
 *
 * To run a mutation, you first call `useUpsertOfflineAttendeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOfflineAttendeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOfflineAttendeeMutation, { data, loading, error }] = useUpsertOfflineAttendeeMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertOfflineAttendeeMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOfflineAttendeeMutation, UpsertOfflineAttendeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOfflineAttendeeMutation, UpsertOfflineAttendeeMutationVariables>(UpsertOfflineAttendeeDocument, options);
      }
export type UpsertOfflineAttendeeMutationHookResult = ReturnType<typeof useUpsertOfflineAttendeeMutation>;
export type UpsertOfflineAttendeeMutationResult = Apollo.MutationResult<UpsertOfflineAttendeeMutation>;
export type UpsertOfflineAttendeeMutationOptions = Apollo.BaseMutationOptions<UpsertOfflineAttendeeMutation, UpsertOfflineAttendeeMutationVariables>;
export const UpsertOriginalContentsDocument = gql`
    mutation upsertOriginalContents($objects: [mix_content_insert_input!]!) {
  insert_mix_content(
    objects: $objects
    on_conflict: {constraint: mix_content_source_contentid_key, update_columns: [abstractcontents, author, authorname, imgurl, cover_imgurl, originalurl, readtime, redirecturl, title, updatetime]}
  ) {
    returning {
      id
    }
  }
}
    `;
export type UpsertOriginalContentsMutationFn = Apollo.MutationFunction<UpsertOriginalContentsMutation, UpsertOriginalContentsMutationVariables>;
export type UpsertOriginalContentsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertOriginalContentsMutation, UpsertOriginalContentsMutationVariables>, 'mutation'>;

    export const UpsertOriginalContentsComponent = (props: UpsertOriginalContentsComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertOriginalContentsMutation, UpsertOriginalContentsMutationVariables> mutation={UpsertOriginalContentsDocument} {...props} />
    );
    

/**
 * __useUpsertOriginalContentsMutation__
 *
 * To run a mutation, you first call `useUpsertOriginalContentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertOriginalContentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertOriginalContentsMutation, { data, loading, error }] = useUpsertOriginalContentsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertOriginalContentsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertOriginalContentsMutation, UpsertOriginalContentsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertOriginalContentsMutation, UpsertOriginalContentsMutationVariables>(UpsertOriginalContentsDocument, options);
      }
export type UpsertOriginalContentsMutationHookResult = ReturnType<typeof useUpsertOriginalContentsMutation>;
export type UpsertOriginalContentsMutationResult = Apollo.MutationResult<UpsertOriginalContentsMutation>;
export type UpsertOriginalContentsMutationOptions = Apollo.BaseMutationOptions<UpsertOriginalContentsMutation, UpsertOriginalContentsMutationVariables>;
export const UpsertUserInterestTagsDocument = gql`
    mutation upsertUserInterestTags($objects: [mix_user_interest_tag_insert_input!]!) {
  insert_mix_user_interest_tag(
    objects: $objects
    on_conflict: {constraint: mix_user_interest_tag_pkey, update_columns: [priority, updated_at]}
  ) {
    returning {
      user_id
      tag_value
      priority
      created_at
      updated_at
    }
  }
}
    `;
export type UpsertUserInterestTagsMutationFn = Apollo.MutationFunction<UpsertUserInterestTagsMutation, UpsertUserInterestTagsMutationVariables>;
export type UpsertUserInterestTagsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpsertUserInterestTagsMutation, UpsertUserInterestTagsMutationVariables>, 'mutation'>;

    export const UpsertUserInterestTagsComponent = (props: UpsertUserInterestTagsComponentProps) => (
      <ApolloReactComponents.Mutation<UpsertUserInterestTagsMutation, UpsertUserInterestTagsMutationVariables> mutation={UpsertUserInterestTagsDocument} {...props} />
    );
    

/**
 * __useUpsertUserInterestTagsMutation__
 *
 * To run a mutation, you first call `useUpsertUserInterestTagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertUserInterestTagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertUserInterestTagsMutation, { data, loading, error }] = useUpsertUserInterestTagsMutation({
 *   variables: {
 *      objects: // value for 'objects'
 *   },
 * });
 */
export function useUpsertUserInterestTagsMutation(baseOptions?: Apollo.MutationHookOptions<UpsertUserInterestTagsMutation, UpsertUserInterestTagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertUserInterestTagsMutation, UpsertUserInterestTagsMutationVariables>(UpsertUserInterestTagsDocument, options);
      }
export type UpsertUserInterestTagsMutationHookResult = ReturnType<typeof useUpsertUserInterestTagsMutation>;
export type UpsertUserInterestTagsMutationResult = Apollo.MutationResult<UpsertUserInterestTagsMutation>;
export type UpsertUserInterestTagsMutationOptions = Apollo.BaseMutationOptions<UpsertUserInterestTagsMutation, UpsertUserInterestTagsMutationVariables>;
export const CreateGuestUserDocument = gql`
    mutation CreateGuestUser($guestUserId: uuid!, $guestEmail: String!) {
  insert_mix_user_one(
    object: {id: $guestUserId, name: "Guest User", email: $guestEmail, profileImg: "", method: "guest"}
    on_conflict: {constraint: mix_user_pkey, update_columns: []}
  ) {
    id
  }
}
    `;
export type CreateGuestUserMutationFn = Apollo.MutationFunction<CreateGuestUserMutation, CreateGuestUserMutationVariables>;
export type CreateGuestUserComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateGuestUserMutation, CreateGuestUserMutationVariables>, 'mutation'>;

    export const CreateGuestUserComponent = (props: CreateGuestUserComponentProps) => (
      <ApolloReactComponents.Mutation<CreateGuestUserMutation, CreateGuestUserMutationVariables> mutation={CreateGuestUserDocument} {...props} />
    );
    

/**
 * __useCreateGuestUserMutation__
 *
 * To run a mutation, you first call `useCreateGuestUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGuestUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGuestUserMutation, { data, loading, error }] = useCreateGuestUserMutation({
 *   variables: {
 *      guestUserId: // value for 'guestUserId'
 *      guestEmail: // value for 'guestEmail'
 *   },
 * });
 */
export function useCreateGuestUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateGuestUserMutation, CreateGuestUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGuestUserMutation, CreateGuestUserMutationVariables>(CreateGuestUserDocument, options);
      }
export type CreateGuestUserMutationHookResult = ReturnType<typeof useCreateGuestUserMutation>;
export type CreateGuestUserMutationResult = Apollo.MutationResult<CreateGuestUserMutation>;
export type CreateGuestUserMutationOptions = Apollo.BaseMutationOptions<CreateGuestUserMutation, CreateGuestUserMutationVariables>;
export const SubmitVoteDocument = gql`
    mutation SubmitVote($voteId: uuid!, $selectedOption: Int!) {
  insert_mix_user_vote_one(
    object: {vote_id: $voteId, selected_option: $selectedOption}
    on_conflict: {constraint: mix_user_vote_vote_id_user_id_key, update_columns: [selected_option]}
  ) {
    id
    selected_option
    created_at
    updated_at
  }
}
    `;
export type SubmitVoteMutationFn = Apollo.MutationFunction<SubmitVoteMutation, SubmitVoteMutationVariables>;
export type SubmitVoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitVoteMutation, SubmitVoteMutationVariables>, 'mutation'>;

    export const SubmitVoteComponent = (props: SubmitVoteComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitVoteMutation, SubmitVoteMutationVariables> mutation={SubmitVoteDocument} {...props} />
    );
    

/**
 * __useSubmitVoteMutation__
 *
 * To run a mutation, you first call `useSubmitVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitVoteMutation, { data, loading, error }] = useSubmitVoteMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      selectedOption: // value for 'selectedOption'
 *   },
 * });
 */
export function useSubmitVoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitVoteMutation, SubmitVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitVoteMutation, SubmitVoteMutationVariables>(SubmitVoteDocument, options);
      }
export type SubmitVoteMutationHookResult = ReturnType<typeof useSubmitVoteMutation>;
export type SubmitVoteMutationResult = Apollo.MutationResult<SubmitVoteMutation>;
export type SubmitVoteMutationOptions = Apollo.BaseMutationOptions<SubmitVoteMutation, SubmitVoteMutationVariables>;
export const SubmitGuestVoteDocument = gql`
    mutation SubmitGuestVote($voteId: uuid!, $userId: uuid!, $selectedOption: Int!) {
  insert_mix_user_vote_one(
    object: {vote_id: $voteId, user_id: $userId, selected_option: $selectedOption}
    on_conflict: {constraint: mix_user_vote_vote_id_user_id_key, update_columns: [selected_option]}
  ) {
    id
    user_id
    selected_option
    created_at
    updated_at
  }
}
    `;
export type SubmitGuestVoteMutationFn = Apollo.MutationFunction<SubmitGuestVoteMutation, SubmitGuestVoteMutationVariables>;
export type SubmitGuestVoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<SubmitGuestVoteMutation, SubmitGuestVoteMutationVariables>, 'mutation'>;

    export const SubmitGuestVoteComponent = (props: SubmitGuestVoteComponentProps) => (
      <ApolloReactComponents.Mutation<SubmitGuestVoteMutation, SubmitGuestVoteMutationVariables> mutation={SubmitGuestVoteDocument} {...props} />
    );
    

/**
 * __useSubmitGuestVoteMutation__
 *
 * To run a mutation, you first call `useSubmitGuestVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitGuestVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitGuestVoteMutation, { data, loading, error }] = useSubmitGuestVoteMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      userId: // value for 'userId'
 *      selectedOption: // value for 'selectedOption'
 *   },
 * });
 */
export function useSubmitGuestVoteMutation(baseOptions?: Apollo.MutationHookOptions<SubmitGuestVoteMutation, SubmitGuestVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitGuestVoteMutation, SubmitGuestVoteMutationVariables>(SubmitGuestVoteDocument, options);
      }
export type SubmitGuestVoteMutationHookResult = ReturnType<typeof useSubmitGuestVoteMutation>;
export type SubmitGuestVoteMutationResult = Apollo.MutationResult<SubmitGuestVoteMutation>;
export type SubmitGuestVoteMutationOptions = Apollo.BaseMutationOptions<SubmitGuestVoteMutation, SubmitGuestVoteMutationVariables>;
export const DeleteVoteDocument = gql`
    mutation DeleteVote($voteId: uuid!) {
  delete_mix_user_vote(where: {vote_id: {_eq: $voteId}}) {
    affected_rows
  }
}
    `;
export type DeleteVoteMutationFn = Apollo.MutationFunction<DeleteVoteMutation, DeleteVoteMutationVariables>;
export type DeleteVoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteVoteMutation, DeleteVoteMutationVariables>, 'mutation'>;

    export const DeleteVoteComponent = (props: DeleteVoteComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteVoteMutation, DeleteVoteMutationVariables> mutation={DeleteVoteDocument} {...props} />
    );
    

/**
 * __useDeleteVoteMutation__
 *
 * To run a mutation, you first call `useDeleteVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoteMutation, { data, loading, error }] = useDeleteVoteMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *   },
 * });
 */
export function useDeleteVoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVoteMutation, DeleteVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVoteMutation, DeleteVoteMutationVariables>(DeleteVoteDocument, options);
      }
export type DeleteVoteMutationHookResult = ReturnType<typeof useDeleteVoteMutation>;
export type DeleteVoteMutationResult = Apollo.MutationResult<DeleteVoteMutation>;
export type DeleteVoteMutationOptions = Apollo.BaseMutationOptions<DeleteVoteMutation, DeleteVoteMutationVariables>;
export const DeleteGuestVoteDocument = gql`
    mutation DeleteGuestVote($voteId: uuid!, $userId: uuid!) {
  delete_mix_user_vote(where: {vote_id: {_eq: $voteId}, user_id: {_eq: $userId}}) {
    affected_rows
  }
}
    `;
export type DeleteGuestVoteMutationFn = Apollo.MutationFunction<DeleteGuestVoteMutation, DeleteGuestVoteMutationVariables>;
export type DeleteGuestVoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteGuestVoteMutation, DeleteGuestVoteMutationVariables>, 'mutation'>;

    export const DeleteGuestVoteComponent = (props: DeleteGuestVoteComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteGuestVoteMutation, DeleteGuestVoteMutationVariables> mutation={DeleteGuestVoteDocument} {...props} />
    );
    

/**
 * __useDeleteGuestVoteMutation__
 *
 * To run a mutation, you first call `useDeleteGuestVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteGuestVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteGuestVoteMutation, { data, loading, error }] = useDeleteGuestVoteMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useDeleteGuestVoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteGuestVoteMutation, DeleteGuestVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteGuestVoteMutation, DeleteGuestVoteMutationVariables>(DeleteGuestVoteDocument, options);
      }
export type DeleteGuestVoteMutationHookResult = ReturnType<typeof useDeleteGuestVoteMutation>;
export type DeleteGuestVoteMutationResult = Apollo.MutationResult<DeleteGuestVoteMutation>;
export type DeleteGuestVoteMutationOptions = Apollo.BaseMutationOptions<DeleteGuestVoteMutation, DeleteGuestVoteMutationVariables>;
export const CreateVoteDocument = gql`
    mutation CreateVote($question: String!, $firstOption: String!, $secondOption: String!, $description: String, $startDate: timestamptz, $endDate: timestamptz) {
  insert_mix_vote_one(
    object: {question: $question, first_option: $firstOption, second_option: $secondOption, description: $description, start_date: $startDate, end_date: $endDate, status: "active"}
  ) {
    id
    question
    first_option
    second_option
    description
    status
    created_at
  }
}
    `;
export type CreateVoteMutationFn = Apollo.MutationFunction<CreateVoteMutation, CreateVoteMutationVariables>;
export type CreateVoteComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateVoteMutation, CreateVoteMutationVariables>, 'mutation'>;

    export const CreateVoteComponent = (props: CreateVoteComponentProps) => (
      <ApolloReactComponents.Mutation<CreateVoteMutation, CreateVoteMutationVariables> mutation={CreateVoteDocument} {...props} />
    );
    

/**
 * __useCreateVoteMutation__
 *
 * To run a mutation, you first call `useCreateVoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoteMutation, { data, loading, error }] = useCreateVoteMutation({
 *   variables: {
 *      question: // value for 'question'
 *      firstOption: // value for 'firstOption'
 *      secondOption: // value for 'secondOption'
 *      description: // value for 'description'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useCreateVoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateVoteMutation, CreateVoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVoteMutation, CreateVoteMutationVariables>(CreateVoteDocument, options);
      }
export type CreateVoteMutationHookResult = ReturnType<typeof useCreateVoteMutation>;
export type CreateVoteMutationResult = Apollo.MutationResult<CreateVoteMutation>;
export type CreateVoteMutationOptions = Apollo.BaseMutationOptions<CreateVoteMutation, CreateVoteMutationVariables>;
export const UpdateVoteStatusDocument = gql`
    mutation UpdateVoteStatus($voteId: uuid!, $status: String!) {
  update_mix_vote_by_pk(pk_columns: {id: $voteId}, _set: {status: $status}) {
    id
    status
    updated_at
  }
}
    `;
export type UpdateVoteStatusMutationFn = Apollo.MutationFunction<UpdateVoteStatusMutation, UpdateVoteStatusMutationVariables>;
export type UpdateVoteStatusComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateVoteStatusMutation, UpdateVoteStatusMutationVariables>, 'mutation'>;

    export const UpdateVoteStatusComponent = (props: UpdateVoteStatusComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateVoteStatusMutation, UpdateVoteStatusMutationVariables> mutation={UpdateVoteStatusDocument} {...props} />
    );
    

/**
 * __useUpdateVoteStatusMutation__
 *
 * To run a mutation, you first call `useUpdateVoteStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoteStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoteStatusMutation, { data, loading, error }] = useUpdateVoteStatusMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateVoteStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVoteStatusMutation, UpdateVoteStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVoteStatusMutation, UpdateVoteStatusMutationVariables>(UpdateVoteStatusDocument, options);
      }
export type UpdateVoteStatusMutationHookResult = ReturnType<typeof useUpdateVoteStatusMutation>;
export type UpdateVoteStatusMutationResult = Apollo.MutationResult<UpdateVoteStatusMutation>;
export type UpdateVoteStatusMutationOptions = Apollo.BaseMutationOptions<UpdateVoteStatusMutation, UpdateVoteStatusMutationVariables>;
export const AddVoteCommentDocument = gql`
    mutation AddVoteComment($voteId: uuid!, $text: String!, $parentCommentId: uuid, $isAnonymous: Boolean = false, $anonymousNickname: String, $anonymousAvatarSeed: String) {
  insert_mix_user_vote_comment_one(
    object: {vote_id: $voteId, text: $text, parent_comment_id: $parentCommentId, is_anonymous: $isAnonymous, anonymous_nickname: $anonymousNickname, anonymous_avatar_seed: $anonymousAvatarSeed}
  ) {
    id
    text
    created_at
    is_anonymous
    anonymous_nickname
    anonymous_avatar_seed
    parent_comment_id
    reply_count
    mix_user {
      id
      name
      profileImg
    }
  }
}
    `;
export type AddVoteCommentMutationFn = Apollo.MutationFunction<AddVoteCommentMutation, AddVoteCommentMutationVariables>;
export type AddVoteCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddVoteCommentMutation, AddVoteCommentMutationVariables>, 'mutation'>;

    export const AddVoteCommentComponent = (props: AddVoteCommentComponentProps) => (
      <ApolloReactComponents.Mutation<AddVoteCommentMutation, AddVoteCommentMutationVariables> mutation={AddVoteCommentDocument} {...props} />
    );
    

/**
 * __useAddVoteCommentMutation__
 *
 * To run a mutation, you first call `useAddVoteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddVoteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addVoteCommentMutation, { data, loading, error }] = useAddVoteCommentMutation({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      text: // value for 'text'
 *      parentCommentId: // value for 'parentCommentId'
 *      isAnonymous: // value for 'isAnonymous'
 *      anonymousNickname: // value for 'anonymousNickname'
 *      anonymousAvatarSeed: // value for 'anonymousAvatarSeed'
 *   },
 * });
 */
export function useAddVoteCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddVoteCommentMutation, AddVoteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddVoteCommentMutation, AddVoteCommentMutationVariables>(AddVoteCommentDocument, options);
      }
export type AddVoteCommentMutationHookResult = ReturnType<typeof useAddVoteCommentMutation>;
export type AddVoteCommentMutationResult = Apollo.MutationResult<AddVoteCommentMutation>;
export type AddVoteCommentMutationOptions = Apollo.BaseMutationOptions<AddVoteCommentMutation, AddVoteCommentMutationVariables>;
export const DeleteVoteCommentDocument = gql`
    mutation DeleteVoteComment($commentId: uuid!) {
  delete_mix_user_vote_comment_by_pk(id: $commentId) {
    id
  }
}
    `;
export type DeleteVoteCommentMutationFn = Apollo.MutationFunction<DeleteVoteCommentMutation, DeleteVoteCommentMutationVariables>;
export type DeleteVoteCommentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteVoteCommentMutation, DeleteVoteCommentMutationVariables>, 'mutation'>;

    export const DeleteVoteCommentComponent = (props: DeleteVoteCommentComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteVoteCommentMutation, DeleteVoteCommentMutationVariables> mutation={DeleteVoteCommentDocument} {...props} />
    );
    

/**
 * __useDeleteVoteCommentMutation__
 *
 * To run a mutation, you first call `useDeleteVoteCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVoteCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVoteCommentMutation, { data, loading, error }] = useDeleteVoteCommentMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteVoteCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVoteCommentMutation, DeleteVoteCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVoteCommentMutation, DeleteVoteCommentMutationVariables>(DeleteVoteCommentDocument, options);
      }
export type DeleteVoteCommentMutationHookResult = ReturnType<typeof useDeleteVoteCommentMutation>;
export type DeleteVoteCommentMutationResult = Apollo.MutationResult<DeleteVoteCommentMutation>;
export type DeleteVoteCommentMutationOptions = Apollo.BaseMutationOptions<DeleteVoteCommentMutation, DeleteVoteCommentMutationVariables>;
export const ToggleLoveReactionDocument = gql`
    mutation ToggleLoveReaction($commentId: uuid!) {
  insert_mix_user_vote_comment_reaction_one(
    object: {comment_id: $commentId, reaction_type: love}
    on_conflict: {constraint: mix_user_vote_comment_reaction_comment_id_user_id_key, update_columns: []}
  ) {
    id
    reaction_type
    created_at
  }
}
    `;
export type ToggleLoveReactionMutationFn = Apollo.MutationFunction<ToggleLoveReactionMutation, ToggleLoveReactionMutationVariables>;
export type ToggleLoveReactionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ToggleLoveReactionMutation, ToggleLoveReactionMutationVariables>, 'mutation'>;

    export const ToggleLoveReactionComponent = (props: ToggleLoveReactionComponentProps) => (
      <ApolloReactComponents.Mutation<ToggleLoveReactionMutation, ToggleLoveReactionMutationVariables> mutation={ToggleLoveReactionDocument} {...props} />
    );
    

/**
 * __useToggleLoveReactionMutation__
 *
 * To run a mutation, you first call `useToggleLoveReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleLoveReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleLoveReactionMutation, { data, loading, error }] = useToggleLoveReactionMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useToggleLoveReactionMutation(baseOptions?: Apollo.MutationHookOptions<ToggleLoveReactionMutation, ToggleLoveReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleLoveReactionMutation, ToggleLoveReactionMutationVariables>(ToggleLoveReactionDocument, options);
      }
export type ToggleLoveReactionMutationHookResult = ReturnType<typeof useToggleLoveReactionMutation>;
export type ToggleLoveReactionMutationResult = Apollo.MutationResult<ToggleLoveReactionMutation>;
export type ToggleLoveReactionMutationOptions = Apollo.BaseMutationOptions<ToggleLoveReactionMutation, ToggleLoveReactionMutationVariables>;
export const RemoveLoveReactionDocument = gql`
    mutation RemoveLoveReaction($commentId: uuid!) {
  delete_mix_user_vote_comment_reaction(
    where: {comment_id: {_eq: $commentId}, reaction_type: {_eq: love}}
  ) {
    affected_rows
  }
}
    `;
export type RemoveLoveReactionMutationFn = Apollo.MutationFunction<RemoveLoveReactionMutation, RemoveLoveReactionMutationVariables>;
export type RemoveLoveReactionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RemoveLoveReactionMutation, RemoveLoveReactionMutationVariables>, 'mutation'>;

    export const RemoveLoveReactionComponent = (props: RemoveLoveReactionComponentProps) => (
      <ApolloReactComponents.Mutation<RemoveLoveReactionMutation, RemoveLoveReactionMutationVariables> mutation={RemoveLoveReactionDocument} {...props} />
    );
    

/**
 * __useRemoveLoveReactionMutation__
 *
 * To run a mutation, you first call `useRemoveLoveReactionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveLoveReactionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeLoveReactionMutation, { data, loading, error }] = useRemoveLoveReactionMutation({
 *   variables: {
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useRemoveLoveReactionMutation(baseOptions?: Apollo.MutationHookOptions<RemoveLoveReactionMutation, RemoveLoveReactionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveLoveReactionMutation, RemoveLoveReactionMutationVariables>(RemoveLoveReactionDocument, options);
      }
export type RemoveLoveReactionMutationHookResult = ReturnType<typeof useRemoveLoveReactionMutation>;
export type RemoveLoveReactionMutationResult = Apollo.MutationResult<RemoveLoveReactionMutation>;
export type RemoveLoveReactionMutationOptions = Apollo.BaseMutationOptions<RemoveLoveReactionMutation, RemoveLoveReactionMutationVariables>;
export const GetActiveVoteDocument = gql`
    query GetActiveVote($userId: uuid, $includeMyVote: Boolean = false) {
  mix_vote(
    where: {status: {_eq: "active"}}
    limit: 1
    order_by: {created_at: desc}
  ) {
    id
    question
    description
    first_option
    second_option
    start_date
    end_date
    status
    created_at
    mix_user_votes {
      id
      selected_option
      user_id
    }
    mix_user_votes_aggregate {
      aggregate {
        count
      }
    }
    my_vote: mix_user_votes(where: {user_id: {_eq: $userId}}, limit: 1) @include(if: $includeMyVote) {
      id
      selected_option
      created_at
    }
  }
}
    `;
export type GetActiveVoteComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetActiveVoteQuery, GetActiveVoteQueryVariables>, 'query'>;

    export const GetActiveVoteComponent = (props: GetActiveVoteComponentProps) => (
      <ApolloReactComponents.Query<GetActiveVoteQuery, GetActiveVoteQueryVariables> query={GetActiveVoteDocument} {...props} />
    );
    

/**
 * __useGetActiveVoteQuery__
 *
 * To run a query within a React component, call `useGetActiveVoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveVoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveVoteQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeMyVote: // value for 'includeMyVote'
 *   },
 * });
 */
export function useGetActiveVoteQuery(baseOptions?: Apollo.QueryHookOptions<GetActiveVoteQuery, GetActiveVoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveVoteQuery, GetActiveVoteQueryVariables>(GetActiveVoteDocument, options);
      }
export function useGetActiveVoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveVoteQuery, GetActiveVoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveVoteQuery, GetActiveVoteQueryVariables>(GetActiveVoteDocument, options);
        }
export type GetActiveVoteQueryHookResult = ReturnType<typeof useGetActiveVoteQuery>;
export type GetActiveVoteLazyQueryHookResult = ReturnType<typeof useGetActiveVoteLazyQuery>;
export type GetActiveVoteQueryResult = Apollo.QueryResult<GetActiveVoteQuery, GetActiveVoteQueryVariables>;
export const GetAllActiveVotesDocument = gql`
    query GetAllActiveVotes($userId: uuid, $includeMyVote: Boolean = false) {
  mix_vote(where: {status: {_eq: "active"}}, order_by: {created_at: desc}) {
    id
    question
    description
    first_option
    second_option
    start_date
    end_date
    status
    created_at
    mix_user_votes {
      id
      selected_option
      user_id
    }
    mix_user_votes_aggregate {
      aggregate {
        count
      }
    }
    my_vote: mix_user_votes(where: {user_id: {_eq: $userId}}, limit: 1) @include(if: $includeMyVote) {
      id
      selected_option
      created_at
    }
  }
}
    `;
export type GetAllActiveVotesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables>, 'query'>;

    export const GetAllActiveVotesComponent = (props: GetAllActiveVotesComponentProps) => (
      <ApolloReactComponents.Query<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables> query={GetAllActiveVotesDocument} {...props} />
    );
    

/**
 * __useGetAllActiveVotesQuery__
 *
 * To run a query within a React component, call `useGetAllActiveVotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllActiveVotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllActiveVotesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      includeMyVote: // value for 'includeMyVote'
 *   },
 * });
 */
export function useGetAllActiveVotesQuery(baseOptions?: Apollo.QueryHookOptions<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables>(GetAllActiveVotesDocument, options);
      }
export function useGetAllActiveVotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables>(GetAllActiveVotesDocument, options);
        }
export type GetAllActiveVotesQueryHookResult = ReturnType<typeof useGetAllActiveVotesQuery>;
export type GetAllActiveVotesLazyQueryHookResult = ReturnType<typeof useGetAllActiveVotesLazyQuery>;
export type GetAllActiveVotesQueryResult = Apollo.QueryResult<GetAllActiveVotesQuery, GetAllActiveVotesQueryVariables>;
export const GetVoteCountsDocument = gql`
    query GetVoteCounts($voteId: uuid!) {
  mix_user_vote_count(where: {vote_id: {_eq: $voteId}}) {
    vote_id
    selected_option
    vote_count
    percentage
  }
}
    `;
export type GetVoteCountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVoteCountsQuery, GetVoteCountsQueryVariables>, 'query'> & ({ variables: GetVoteCountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetVoteCountsComponent = (props: GetVoteCountsComponentProps) => (
      <ApolloReactComponents.Query<GetVoteCountsQuery, GetVoteCountsQueryVariables> query={GetVoteCountsDocument} {...props} />
    );
    

/**
 * __useGetVoteCountsQuery__
 *
 * To run a query within a React component, call `useGetVoteCountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoteCountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoteCountsQuery({
 *   variables: {
 *      voteId: // value for 'voteId'
 *   },
 * });
 */
export function useGetVoteCountsQuery(baseOptions: Apollo.QueryHookOptions<GetVoteCountsQuery, GetVoteCountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoteCountsQuery, GetVoteCountsQueryVariables>(GetVoteCountsDocument, options);
      }
export function useGetVoteCountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoteCountsQuery, GetVoteCountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoteCountsQuery, GetVoteCountsQueryVariables>(GetVoteCountsDocument, options);
        }
export type GetVoteCountsQueryHookResult = ReturnType<typeof useGetVoteCountsQuery>;
export type GetVoteCountsLazyQueryHookResult = ReturnType<typeof useGetVoteCountsLazyQuery>;
export type GetVoteCountsQueryResult = Apollo.QueryResult<GetVoteCountsQuery, GetVoteCountsQueryVariables>;
export const GetVoteByIdDocument = gql`
    query GetVoteById($voteId: uuid!, $userId: uuid, $includeMyVote: Boolean = false) {
  vote: mix_vote_by_pk(id: $voteId) {
    id
    question
    description
    first_option
    second_option
    first_image
    second_image
    status
    start_date
    end_date
    created_at
    tags
    content_ids
    mix_user_votes {
      id
      selected_option
      user_id
    }
    mix_user_votes_aggregate {
      aggregate {
        count
      }
    }
    my_vote: mix_user_votes(where: {user_id: {_eq: $userId}}, limit: 1) @include(if: $includeMyVote) {
      id
      selected_option
      created_at
    }
  }
}
    `;
export type GetVoteByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVoteByIdQuery, GetVoteByIdQueryVariables>, 'query'> & ({ variables: GetVoteByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetVoteByIdComponent = (props: GetVoteByIdComponentProps) => (
      <ApolloReactComponents.Query<GetVoteByIdQuery, GetVoteByIdQueryVariables> query={GetVoteByIdDocument} {...props} />
    );
    

/**
 * __useGetVoteByIdQuery__
 *
 * To run a query within a React component, call `useGetVoteByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoteByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoteByIdQuery({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      userId: // value for 'userId'
 *      includeMyVote: // value for 'includeMyVote'
 *   },
 * });
 */
export function useGetVoteByIdQuery(baseOptions: Apollo.QueryHookOptions<GetVoteByIdQuery, GetVoteByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoteByIdQuery, GetVoteByIdQueryVariables>(GetVoteByIdDocument, options);
      }
export function useGetVoteByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoteByIdQuery, GetVoteByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoteByIdQuery, GetVoteByIdQueryVariables>(GetVoteByIdDocument, options);
        }
export type GetVoteByIdQueryHookResult = ReturnType<typeof useGetVoteByIdQuery>;
export type GetVoteByIdLazyQueryHookResult = ReturnType<typeof useGetVoteByIdLazyQuery>;
export type GetVoteByIdQueryResult = Apollo.QueryResult<GetVoteByIdQuery, GetVoteByIdQueryVariables>;
export const GetVoteCommentsDocument = gql`
    query GetVoteComments($voteId: uuid!, $limit: Int = 20, $offset: Int = 0) {
  comments: mix_user_vote_comment(
    where: {vote_id: {_eq: $voteId}}
    order_by: {created_at: asc}
    limit: $limit
    offset: $offset
  ) {
    ...CommentFields
  }
  comments_aggregate: mix_user_vote_comment_aggregate(
    where: {vote_id: {_eq: $voteId}}
  ) {
    aggregate {
      count
    }
  }
}
    ${CommentFieldsFragmentDoc}`;
export type GetVoteCommentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetVoteCommentsQuery, GetVoteCommentsQueryVariables>, 'query'> & ({ variables: GetVoteCommentsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetVoteCommentsComponent = (props: GetVoteCommentsComponentProps) => (
      <ApolloReactComponents.Query<GetVoteCommentsQuery, GetVoteCommentsQueryVariables> query={GetVoteCommentsDocument} {...props} />
    );
    

/**
 * __useGetVoteCommentsQuery__
 *
 * To run a query within a React component, call `useGetVoteCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoteCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoteCommentsQuery({
 *   variables: {
 *      voteId: // value for 'voteId'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useGetVoteCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetVoteCommentsQuery, GetVoteCommentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoteCommentsQuery, GetVoteCommentsQueryVariables>(GetVoteCommentsDocument, options);
      }
export function useGetVoteCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoteCommentsQuery, GetVoteCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoteCommentsQuery, GetVoteCommentsQueryVariables>(GetVoteCommentsDocument, options);
        }
export type GetVoteCommentsQueryHookResult = ReturnType<typeof useGetVoteCommentsQuery>;
export type GetVoteCommentsLazyQueryHookResult = ReturnType<typeof useGetVoteCommentsLazyQuery>;
export type GetVoteCommentsQueryResult = Apollo.QueryResult<GetVoteCommentsQuery, GetVoteCommentsQueryVariables>;
export const GetMyReactionsDocument = gql`
    query GetMyReactions($commentIds: [uuid!]!, $userId: uuid!) {
  mix_user_vote_comment_reaction(
    where: {comment_id: {_in: $commentIds}, user_id: {_eq: $userId}}
  ) {
    id
    comment_id
    reaction_type
  }
}
    `;
export type GetMyReactionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMyReactionsQuery, GetMyReactionsQueryVariables>, 'query'> & ({ variables: GetMyReactionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetMyReactionsComponent = (props: GetMyReactionsComponentProps) => (
      <ApolloReactComponents.Query<GetMyReactionsQuery, GetMyReactionsQueryVariables> query={GetMyReactionsDocument} {...props} />
    );
    

/**
 * __useGetMyReactionsQuery__
 *
 * To run a query within a React component, call `useGetMyReactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyReactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyReactionsQuery({
 *   variables: {
 *      commentIds: // value for 'commentIds'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetMyReactionsQuery(baseOptions: Apollo.QueryHookOptions<GetMyReactionsQuery, GetMyReactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyReactionsQuery, GetMyReactionsQueryVariables>(GetMyReactionsDocument, options);
      }
export function useGetMyReactionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyReactionsQuery, GetMyReactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyReactionsQuery, GetMyReactionsQueryVariables>(GetMyReactionsDocument, options);
        }
export type GetMyReactionsQueryHookResult = ReturnType<typeof useGetMyReactionsQuery>;
export type GetMyReactionsLazyQueryHookResult = ReturnType<typeof useGetMyReactionsLazyQuery>;
export type GetMyReactionsQueryResult = Apollo.QueryResult<GetMyReactionsQuery, GetMyReactionsQueryVariables>;
export const WeeklyPopularContentsDocument = gql`
    query WeeklyPopularContents($fetchLimit: Int = 20, $excludeContentIds: [uuid!] = []) {
  popular: mix_content_popular_last_7days_view(
    limit: $fetchLimit
    order_by: {view_count: desc}
    where: {contentid: {_nin: $excludeContentIds}}
  ) {
    contentid
    view_count
    mix_content_id {
      ...mix_content
    }
  }
}
    ${Mix_ContentFragmentDoc}`;
export type WeeklyPopularContentsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables>, 'query'>;

    export const WeeklyPopularContentsComponent = (props: WeeklyPopularContentsComponentProps) => (
      <ApolloReactComponents.Query<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables> query={WeeklyPopularContentsDocument} {...props} />
    );
    

/**
 * __useWeeklyPopularContentsQuery__
 *
 * To run a query within a React component, call `useWeeklyPopularContentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyPopularContentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyPopularContentsQuery({
 *   variables: {
 *      fetchLimit: // value for 'fetchLimit'
 *      excludeContentIds: // value for 'excludeContentIds'
 *   },
 * });
 */
export function useWeeklyPopularContentsQuery(baseOptions?: Apollo.QueryHookOptions<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables>(WeeklyPopularContentsDocument, options);
      }
export function useWeeklyPopularContentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables>(WeeklyPopularContentsDocument, options);
        }
export type WeeklyPopularContentsQueryHookResult = ReturnType<typeof useWeeklyPopularContentsQuery>;
export type WeeklyPopularContentsLazyQueryHookResult = ReturnType<typeof useWeeklyPopularContentsLazyQuery>;
export type WeeklyPopularContentsQueryResult = Apollo.QueryResult<WeeklyPopularContentsQuery, WeeklyPopularContentsQueryVariables>;
export const WeeklyPopularContentsByDateRangeDocument = gql`
    query WeeklyPopularContentsByDateRange($startDate: timestamp!, $endDate: timestamp!) {
  mix_content_view(where: {createtime: {_gte: $startDate, _lte: $endDate}}) {
    contentid
    createtime
  }
}
    `;
export type WeeklyPopularContentsByDateRangeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables>, 'query'> & ({ variables: WeeklyPopularContentsByDateRangeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const WeeklyPopularContentsByDateRangeComponent = (props: WeeklyPopularContentsByDateRangeComponentProps) => (
      <ApolloReactComponents.Query<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables> query={WeeklyPopularContentsByDateRangeDocument} {...props} />
    );
    

/**
 * __useWeeklyPopularContentsByDateRangeQuery__
 *
 * To run a query within a React component, call `useWeeklyPopularContentsByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useWeeklyPopularContentsByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWeeklyPopularContentsByDateRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useWeeklyPopularContentsByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables>(WeeklyPopularContentsByDateRangeDocument, options);
      }
export function useWeeklyPopularContentsByDateRangeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables>(WeeklyPopularContentsByDateRangeDocument, options);
        }
export type WeeklyPopularContentsByDateRangeQueryHookResult = ReturnType<typeof useWeeklyPopularContentsByDateRangeQuery>;
export type WeeklyPopularContentsByDateRangeLazyQueryHookResult = ReturnType<typeof useWeeklyPopularContentsByDateRangeLazyQuery>;
export type WeeklyPopularContentsByDateRangeQueryResult = Apollo.QueryResult<WeeklyPopularContentsByDateRangeQuery, WeeklyPopularContentsByDateRangeQueryVariables>;

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {}
};
      export default result;
    